import {countries} from "@/locale/countries";
import {E_SERVICE_PROVIDER_TAG_TYPES} from "@/model/Service/serviceProviderInterfaces";

const messages = {
  locale: 'en-GB',
  localeFallbacks: [
    'es-ES',
  ],
  countries: countries,

  home: {
    welcome: 'Welcome to the SmartPoint Backoffice',
    subtitle: 'Select a section from the menu or use the shortcuts below',
    shortcuts: {
      lockers: 'SmartPoints',
      users: 'Users',
      orders: 'Orders',
      providers: 'Providers',
      reports: 'Reports',
      settings: 'Settings',
    },
  },

  common: {
    community: 'Community',
    quantity: 'Quantity',
    active: 'Active',
    address: 'Address',
    all: 'All',
    assigned: 'Assigned',
    autoGenerated: 'Automatically generated',
    applyFilter:'Apply filter',
    back: 'Back',
    cancel: 'Cancel',
    clickToAdd: 'Click to add',
    close: 'Close',
    colorPicker: 'Pick a color',
    comingUp: 'a time may come soon',
    confirmDelete: {
      title: "Delete item",
      description: "This can't be undone. Are you sure?"
    },
    delete: "Delete",
    confirmOperation: 'Confirm operation',
    contact: 'Contact',
    count: 'Count',
    createdAt: 'Created',
    date: 'Date',
    today: 'Today',
    yesterday: 'Yesterday',
    deleted: 'Deleted',
    notDeleted: 'Not deleted',
    // FFS
    create: 'Create',
    description: 'Description',
    details: 'Details',
    recordDetails: 'Record details',
    dni: 'DNI/NIF/NIE',
    edit: 'Edit',
    email: 'Email',
    error: 'Error',
    required: "This field is required.",
    validation: {
      required: 'This field is required.',
      min: 'Minimum {min} characters.',
      numeric: 'Must be a valid number.',
    },
    errorHappened: 'An error happened.',
    errorImg: 'The image could not be loaded.',
    expiresAt: 'Expires',
    features: 'Features',
    fileNotFound: 'File not found',
    filters: 'Filters',
    filterSaved: 'Filter saved',
    filterApplied: 'Filter applied',
    finish: 'Finalize',
    from: 'From',
    id: 'ID',
    language: 'Language',
    languageCodes: {
      en: 'English',
      es: 'Spanish',
      ca: 'Catalan',
    },
    loading: 'loading...',
    locker: 'Smart Point',
    map: 'Map',
    maxPrice: 'Maximum price',
    minPrice: 'Minimum price',
    more: 'More',
    name: 'Name',
    'new': 'New',
    next: 'Next',
    noData: 'No data',
    organization: 'Organization',
    noItems: 'No items',
    noLuck: 'No luck',
    note: 'Note',
    notSet: 'Not set (select one)',
    ok: 'OK',
    onCommunities: 'On community',
    onLockers: 'On Smart Points',
    onlyActive: 'Only active',
    onlyAssigned: 'Only assigned',
    order: 'Order',
    ownTitle: 'Your majesty',
    price: 'Price',
    provider: 'Provider',
    providers: 'Providers',
    reasonWhy: 'Please enter the reason',
    refresh: 'Refresh',
    save: 'Save',
    saved: 'Saved OK',
    saveFilter: 'Save filter',
    search: 'Search',
    serviceProvider: 'Provider',
    serviceProviders: 'Providers',
    settings: 'Settings',
    show: 'Show',
    showAll: 'Show all',
    showMore: 'Show more',
    skip: 'Skip',
    slug: "Slug",
    status: 'Status',
    uptime: 'Uptime',
    type: 'Type',
    typeToSearch: 'type to search',
    to: 'To',
    tooShort: 'keep typing...',
    unknown: 'Unknown',
    updatedAt: 'Last update',
    uploadImage: {
      title: 'Confirm upload?',
      description: 'you have selected file:',
      success: 'Image saved',
      loginNeeded: 'If you see this message, you probably have to log in again',
      clickOrDragHere: 'click to add an image here',
      clickOrDragToUpload: 'click in the box to upload a new image one',
    },
    url: 'URL',
    user: 'User',
    verifiedOK: 'Verified',
    verifiedKO: 'Not yet verified',
    when: 'When',
    where: 'Where',
    yes: 'Yes',
    no: 'No',

    CTA: {
      chooseCellSize: 'Choose compartment size',
      clickToChange: 'Click to change',
      clickToCopy: 'Click to copy to clipboard',
      clickToDownload: 'Click to download',
      clickToEdit: 'Click to edit',
      clickToFilter: 'Click to apply as filter',
      clickToOpenInNew: 'Click to open in new window',
      contextMenu: 'Right click/long touch to see options',
      'delete': 'Press to delete',
      detailsOrEdit: {
        title: 'Details / edit',
        description: 'See details, adjust settings, upload photos, etc',
      },
      edit: 'Edit details',
      gotoOld: 'Go to old page',
      showOnlyActive: 'Show only active ones',
      view: 'View details',
    },
    cta: { // bonomo refers cta as lowercase
      showMore: 'Show more',
      showAll: {
        hintOn: 'Showing all items, including test ones. Click to hide them.',
        hintOff: 'Not showing test items. Click to show them.',
      },
      showDeleted: {
        hintOn: 'Showing deleted items too. Click to hide them.',
        hintOff: 'Not showing deleted items. Click to show them.',
      },
    },
    logs: {
      title: 'Logs',
      headers: {
        action: 'Action',
        data: 'Details',
        description: 'Description',
        when: 'When',
      },
      fields: {
        o: {
          label: 'Origin',
          values: {
            0: 'UNKNOWN',
            20: 'IMPORTER',
            21: 'DIFFUSION EXPRESS',
            50: 'CONSOLE',
            51: 'MANUAL',
            52: 'Garbage collector',
            100: 'BAO old backoffice',
            202: 'API_V2 locker',
            203: 'API_V3 locker',
            302: 'LOCKER_INTERNAL_DELIVERY_V2 locker',
            401: 'API_M1 modulo',
            501: 'API_B1 webapp',
            601: 'API_G1',
            611: 'API_H1',
            621: 'API_X1',
            30: 'API_M1 modulo', // kept here for compatibilitiy - been used betwee 2022/10 and 2023/10 and these are not migrated
            9999: 'INTERNAL',
          },
        },
        u: {
          label: 'User',
        },
      },
    },
    weekDays: {
      0: 'every day',
      1: 'Monday',
      2: 'Tuesday',
      3: 'Wednesday',
      4: 'Thursday',
      5: 'Friday',
      6: 'Saturday',
      7: 'Sunday',
      title: 'Weekday',
    },
    daysOfWeek: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    paginator: {
      showing: 'Showing',
      of: 'of',
      rowsPerPage: 'Rows listed',
    }
  },
  help: {
    orderDeleteConfirm: "Deleting the order will effectively close the order, remove payments etc. Order data like details and logs will be kept but the order will be invisible for users and administrators by default. This operation can not be undone.",
    restrictCells: "By selecting one or more providers, this cell will be available only for those. It will not be used by other providers or package delivery.",
  },
  errors: {
    serviceProvider: {
      title: 'Incomplete Service Provider',
      please: "Please",
      brandImage: " add a brand image",
      logoImage: " add a logo image",
      descriptions: " complete the descriptions",
      and: ' and ',
    },
    image: {
      image_must_be_png: "The image must be a png",
    },
    imageUploaded: {
      image: {
        'mimeTypes:["image/png"]': 'Not a PNG image',
        notTransparent: 'Not a transparent image',
      },
    },
    landingPageCreated: {
      tag: {
        not_found: "Company does not exist",
      },
    },
    lockerLoaded: {
      machine_number: {
        regex: 'The numbers 1000,2000,3000.. are not allowed',
        not_in: 'This number is not allowed',
      }
    },
    orderLoaded: {
      _: {
        'closed': 'This order is closed already',
      },
    },
    serviceProviderLoaded: {
      name: {
        min: 'Min. 5 characters',
      },
      address_line_1: {
        min: 'Min. 5 characters',
      },
      _: {
        unique: 'This service provider is already connected to a different channel. Disconnect it first.',
      },
    },
    usersImported: {
      _: {
        504: 'Looks like it will take a while. Don\'t worry, we continue importing in the background.',
      },
    },
    webhookCreated: {
      _: {
        unique: 'Only one webhook per user and action.',
      },
      url: {
        regex: "The Url must start with https://",
        url: "This is not a correct Url",
        unique: 'This webhook is already added by another client. Please contact Smart Point support',
      }
    },
    submoduleSaved: {
      name: {
        filled: 'Required',
      },
      slug: {
        required: 'The name needs letters or numbers',
        unique: 'This module already has a submodule with this name',
      },
    },
    communityUpdated: {
      submodule_ids: {
        moduleNotEnabled: 'Enable the module of the selected option first',
        onePerModule: 'Only one option can be chosen in this module',
        integrationTypeRequired: 'Choose the integration type',
      },
    },
    general: {
      alpha_dash: "Only letters, numbers and dashes",
      distinct: 'Repeated value',
      email: 'Not a valid email',
      exists: 'No longer exists. Reload the page',
      image_must_be_png: "Image must be png",
      in: 'Invalid value',
      integer: 'Not a whole number',
      min: 'Too short/low',
      min_height: 'Too small (height)',
      min_width: 'Too small (width)',
      no_file: 'No file received',
      numeric: 'Not a number',
      phone: 'Not a valid phone number',
      required: 'Required',
      allLabelsMandatory: 'All "Name" labels are mandatory in all languages.',
      ssh_error: "Can't connect to the machine",
      unique: 'Not unique',
      cannot_change_locker_for_integration_user: 'The locker cannot be changed for a user coming from an integration',
      _: {
        404: 'Not found',
        401: 'Not authorized',
        500: 'Something unexpected happened.',
        'service_provider.channel_mismatch': 'This provider\'s channel does not match the locker\'s community channel.',
        'service_provider.community_restricted': 'This provider is restricted to other communities and cannot be assigned to this locker.',
      }
    },
  },
  tabs: {
    titles : {
      auditLogs: 'Audit Logs',
      identityIntegrations: 'Identity Integrations',
      identityIntegration: 'Identity integration',
      channels: 'Channels',
      translations: 'Translations',
      couriers: 'Couriers',
      home: 'Modulo Backoffice',
      lockersServiceProviders: 'Service providers on SmartPoint',
      lockerCompaniesList: "SmartPoint's companies",
      lockersScreensavers: 'Screensavers on SmartPoint',
      installList: 'Install list',
      installLocker: 'Install SmartPoint',
      lockerList: 'Lockers',
      allStandalonesList: 'Digital Portals',
      locker: 'SmartPoint',
      lockersOrders: 'Orders of...',
      lockersEdit: 'Edit locker',
      lockerEdit: 'Edit locker',
      lockerCreate: 'Create locker',
      lockersContracts: 'Contracts',
      lockersContractsCreate: 'New contract',
      lockersContract: 'Contracts',
      lockersLandingpages: 'Landing pages / flats / etc',
      packagesToTransfer: 'Packages to transfer',
      orderList: 'Orders',
      orderCreate: 'New order',
      orderEdit: 'Edit order',
      orderPrint: 'Print order',
      subscriptionList: 'Subscriptions',
      order: 'Order',
      invoiceList: 'Invoices',
      invoice: 'Invoice',
      realtime: "El Panel de control",
      userPackageDelivery: 'Reception of user packages',
      permissionMap: 'Permission map',
      permissionWhoHas: 'Who has(permissions)',
      reports: 'Reports',
      screensavers: 'Screensavers',
      screensaverInfo: 'Screensavers logs',
      screensaverCreate: 'Create Screensaver',
      screensaversLockers: 'Screensavers on Smartpoint',
      serviceProviderList: 'Providers',
      serviceProviderCreate: 'Create Provider',
      serviceProvider: 'Provider name',
      serviceProvidersServices: 'Service providers',
      serviceCreate: 'Create Service',
      serviceEdit: 'Edit Service',
      serviceProvidersPromotions: 'Provider Promotions',
      serviceProvidersLockers: 'Providers on SmartPoint',
      serviceProviderCategories: 'Provider Categories',
      serviceProviderTimeLine: 'Time Line',
      serviceProviderMetrics: 'Monthly Metrics',
      deliverySettings: 'Delivery Settings',
      themes: 'Themes',
      themeEdit: 'Edit Theme',
      holidays: 'Holidays',
      landingpages: 'Landing pages',
      zones: 'Zones',
      zone: 'Zone',
      swaggerUi: 'Swagger UI',
      userImport: 'Diffusion platform',
      diffusionExpress: 'Diffusion express',
      userList: 'Users',
      user: 'User',
      userEdit: 'Edit user',
      userCommunications: 'Communications',
      userPermissions: 'Permissions',
      userPromotions: 'Promotions',
      userOrderLists: 'Orders',
      userAddresses: 'Addresses',
      userMgm: 'MGM',
      userWebhooks: 'Webhooks',
      userAuditLogs: 'Audit Logs',
      lockerFeatures: 'Features',
      standalonesList: 'Standalones',
      communityStandalonesList: 'Digital Portals',
      standalonePreview: 'Standalone Preview',
      sshconnections: 'SSH Connections',
      businessClientList: 'Clients',
      businessClientCreate: 'New Client',
      businessClient: 'Client',
      businessClientEdit: 'Edit Client',
      businessClientCommunities: 'Client Communities',
      communityList: 'Communities',
      communityCreate: 'New Community',
      community: 'Community',
      communityEdit: 'Edit Community',
      communityModule: 'Community Module',
      communityLockers: 'Community SmartPoints',
      communityB2bInvites: 'Invitation Links',
      communityContacts: 'Community Contacts',
      communityOrders: 'Community Orders',
      communityServiceProviders: 'Service providers on Community',
      communityUsers: 'Community Users',
      route: 'Routes',
      routeList: 'Route list',
      routeEdit: 'Edit route',
      routeCreate: 'Create route',
      messages: 'Messages',
      rentbackSettings: 'Rentback Settings',
      rentbackSettingsEdit: 'Edit Credit Rule',
      rentbackList: 'Rentback',
      securityCodeList: 'Security Pins',
      helpdeskDashboard: 'Helpdesk - Dashboard',
      helpdeskInbox: 'Helpdesk - Inbox',
      helpdeskAccounts: 'Helpdesk - Gmail Accounts',
      helpdeskTickets: 'Helpdesk - Tickets',
      helpdeskSpam: 'Helpdesk - Spam Filter',
      helpdeskTicketTypes: 'Helpdesk - Ticket Types',
      helpdeskSent: 'Helpdesk - Sent Emails',
      helpdeskTemplates: 'Helpdesk - Templates',
      helpdeskSignatures: 'Helpdesk - Signatures',
    },
  },

  channels: {
    title: 'Channels',
    fields: {
      comment: {
        title: 'Comment',
      },
      currency: {
        title: 'Currency',
      },
      payment_provider: {
        title: 'Payment provider',
      },
      requiresDocumentId: {
        title: 'NIE/ID required',
      },
    },
    names: {
      0: '???',
      1: 'Smart Point',
      3: 'Lavalocker',
      4: 'Lagoon',
      5: 'Denmark',
      6: 'Germany',
      7: 'Puig',
      8: 'UK',
      9: 'GMP',
      null: 'No Channel'
    },
  },
  contracts: {
    contracts: {
      title: 'contracts of ',
    },
    contract: {
      title: {
        createContract: 'Create contract',
        viewContract: 'Contract #{entityId}',
        editContract: 'Update contract #{entityId}',
        renewContract: 'Update these fields to renew the contract',
      },
      sections: {
        generalInfo: 'General information',
        invoicing: 'Invoicing',
        costs: 'Costs',
        payments: 'Payments',
        additionalInformation:  'Additional information',
      },
      fields: {
        beginning_contract: {
          label: 'Start contract',
        },
        client_name: {
          label: "Customer name",
        },
        contact_person: {
          label: "Contact person",
        },
        cost_center: {
          label: "Cost center",
          values: {
            Madrid: 'Madrid',
            Barcelona: 'Barcelona',
          },
        },
        discount: {
          label: 'Discount',
        },
        end_contract: {
          label: 'Terminate contract',
        },
        frequency_invoicing: {
          label: 'Frequency invoicing',
          values: {
            'monthly': 'monthly',
            'bimonthly': 'bimonthly',
            'quarterly': 'quarterly',
            'annual': 'annual',
            'biannual': 'biannual',
          },
        },
        installation_date: {
          label: 'Installation',
        },
        installation_cost: {
          label: 'Installation cost (€)',
        },
        invoice_company: {
          label: "Invoice Company",
          values: {
            lavalocker: 'lavalocker',
            sp_income: 'sp_income',
          },
        },
        invoicing_guarantee: {
          label: 'Invoicing Guarantee Date',
        },
        invoicing_install: {
          label: 'Invoicing Install Date',
        },
        invoicing_maintenance: {
          label: 'Invoicing Maintenance Date',
        },
        invoicing_rental: {
          label: 'Invoicing Rental Date',
        },
        invoicing_sales: {
          label: 'Invoicing Sales Date',
        },
        IPC_increase_date: {
          label: 'IPC increase date',
        },
        IPC_increase_percentage: {
          label: 'IPC increase (%)',
        },
        key_account_manager_id: {
          label: "KAM",
        },
        locker_condition: {
          label: "Smart point condition",
          values: {
            'active': 'active',
            'inactive': 'inactive',
          },
        },
        monthly_amount_invoice: {
          label: 'Monthly Invoice Amount (€)',
        },
        payment_terms: {
          label: 'Payment terms',
        },
        production_cost: {
          label: 'Production cost (€)',
        },
        renewal_conditions: {
          label: 'Renewal conditions',
          values: {
            automatic: 'automatic',
            "agreed by the parties": 'agreed by the parties',
          },
        },
        transaction_type: {
          label: 'Transaction Type',
          values: {
            rent: 'rent',
            purchase_sale: 'purchase_sale',
          },
        },

        discount_reason: {
          label: 'Reason of discount',
        },
        location: {
          label: 'Location',
          values: {
            national: 'national',
            international: 'international',
          },
        },
        invoicing_additional_column: {
          label: 'Additional column invoicing (€)',
        },
        payment_type: {
          label: 'Payment type',
          values: {
            direct_debit: 'direct debit',
            transfer: 'transfer',
            cash: 'cash',
            pagare: 'Pagaré',
            cheque: 'cheque',
          },
        },
        renovation_notice_date: {
          label: 'Renovation notice date',
        },
        expansion_renovation: {
          label: 'Expansion renovation',
        },
        last_renovation_date: {
          label: 'Last renovation',
        },
        purchase_order: {
          label: 'Purchase order',
        },
        setup_and_training: {
          label: 'Setup & training (€)',
        },
        rear: {
          label: 'Rear',
        },
        extra_costs: {
          label: 'Extra costs (€)',
        },
        potential: {
          label: 'Potential',
        },
      },
    },
  },
  invoices: {
    titleGeneral: 'Invoices',
    list: {
      title: 'Invoices',
      filterAll: 'All',
      filterNew: 'Pending',
      filterPaid: 'Paid',
      noItems: 'No invoices found',
      searchPlaceholder: 'ID, customer or provider...',
    },
    detail: {
      title: 'Invoice',
      orders: 'Orders',
      payments: 'Payments',
      communications: 'Communications',
      commType: 'Type',
      commStatus: 'Status',
      commContent: 'Message',
      customer: 'Customer',
      serviceProvider: 'Service provider',
      totals: 'Totals',
      grandTotal: 'Grand total',
      subTotal: 'Subtotal',
      vat: 'VAT',
      hasPdf: 'PDF available',
      noPdf: 'No PDF yet',
      date: 'Date',
      fieldName: 'Name',
      fieldEmail: 'Email',
      fieldCompany: 'Company',
      fieldNie: 'NIE',
      fieldAddress: 'Billing address',
    },
    create: {
      title: 'New invoice',
    },
    actions: {
      sendEmail: 'Send invoice',
      addPayment: 'Enter payment',
      delete: 'Delete invoice',
      create: 'Create invoice',
      edit: 'Edit orders',
    },
    payment: {
      amount: 'Amount',
      date: 'Date',
      title: 'Add payment',
    },
    statuses: {
      invoice_new: 'New',
      invoice_awaiting_payment: 'Awaiting payment',
      invoice_paid: 'Paid',
    },
    editOrders: {
      available: 'Available orders',
      selected: 'Selected orders',
      emptyAvailable: 'No available orders',
      emptySelected: 'Drag orders here to add them',
    },
    errors: {
      invoice_without_orders: 'No orders selected',
      missing_billing_information: 'Customer is missing billing info (NIE / company name)',
      missing_default_billing_address: 'Customer has no default billing address',
      missing_service_provider: 'Order has no service provider assigned',
      missing_sp_invoicing_address: 'Service provider has no invoicing address',
      invoice_without_customer: 'Invoice has no customer',
      wrong_amount_specified: 'Invalid amount',
    },
  },
  landingPages:{
    titleOf: 'Landing pages of',
    createDialog: {
      title: "Create new landing page",
      slug: "Slug",
      tag: "Tag",
    }
  },
  lockers: {
    cells: {
      restrictionsDialog: {
        title: "Cell restrictions by provider"
      },
      sizeNames: {
        3: 'Small',
        2: 'Medium',
        4: 'Large',
        5: 'XL',
        1: 'XXL',
      },
      direction: {
        left: 'left',
        right: 'right',
        below: 'under',
        under: 'under',
        center: 'under',
      }
    },
    featureList: {
      confirmationDialog: {
        header1: 'This will turn on ',
        header2: 'This will turn off ',
        header3: ' on Smart Point ',
      }
    },
    install: {
      search: 'Search in all fields name, address, machine, version, OS, CPU, status, last ping',
      title: 'Install list',
      csvExportHint: 'Downloads a CSV with all lockers (install view) matching the current filters.',
      csvLimitTitle: 'Row limit reached',
      csvLimitText: 'You are trying to download more than 1000 lockers, which is the maximum limit. Apply filters to narrow down the results.',
      external_name: {
        title: 'External name',
        popUp: {
          title: 'Edit external name',
          hint: `Name that is used by the client to identify this locker internally`,
          help: `The external name is used to match this Smart Point in SAML integrations`,
        }
      },
      cells: {
        toggle: 'Enable/disable cells',
        oldCells: 'Show/hide disabled cells',
        rotateScreen: 'Rotate screen',
        default: '(default)',
        orientations: {
          normal: 'Normal',
          right: 'Right',
          inverted: 'Inverted',
          left: 'Left',
        },
        toggleSubtitle: 'Disabled cells won’t be allocated for orders',
        connector: 'Conector on board',
        connectorSubtitle: "Edit connector configuration (UNSAFE)",
        id: 'Cell IDs',
        idSubtitle: "Shows each cell's id",
        open: 'Open cells',
        openSubtitle: "For opening a locker's cell",
        openDialog: {
          title: 'Open cell #{cell}',
          subtitle: 'The door should now be unlocked',
          question: 'What do you need to do?',
          orderId: 'Order #{id}',
          delivered: 'Delivered',
          statusLabel: 'Status',
          openAndComplete: 'Open and complete order',
          openCellOnly: 'Open cell only',
          cellIsOpen: 'Cell is open',
          cellOpened: 'Cell opened!',
          orderCompletedToast: 'Order completed!',
          completeOrderQuestion: 'Complete order now?',
          completeOrder: 'Yes, complete order',
          keepOpenCompleteLater: 'Keep open, complete later',
          orderCompleted: 'Order #{id} · {firstName} {lastName} has been completed',
          doorStuckTitle: 'Door not opening?',
          doorStuckBody: 'Contact support and share locker and cell number.',
        },
        accessibility: 'Mark/unmark cells as accessible',
        accessibilitySubtitle: 'Mark cells as accesible for reduced movility people',
        features: {
          disabled: 'Disabled. This cell will not be allocated for orders.',
          accessible: 'Apt for PRM customers (Person with Reduced Mobility)',
        },
        restrictCells: 'Restrict cells',
        restrictCellsSubtitle: 'For restricting locker cells',
        openConfirm: 'Are you sure you want to open this compartment?',
        dwellTime: {
          legendFree: 'Free',
          legendBlocked: 'Blocked',
          legendLess24h: 'Occupied < 24h',
          legend24h: 'Occupied 24h+',
          legend72h: 'Occupied 72h+',
        },
        hideColumn: 'Hide column',
        showColumn: 'Show column',
        columnOrder: 'Column order',
      },
      logo: {
        title: "Change logo",
        noMachineNumber: "Machine number (DM-XXX) was not found. This number is needed to upload a new logo"
      },
      createModule: {
        title: 'New module',
        addColumn: 'Add column',
        restrictUse: 'Restrict use',
      },
    },
    locker: {
      fields: {
        abbreviation: {
          title: 'Abbreviation',
        },
        channel_id: {
          title: 'Channel',
        },
        community_id: {
          title: 'Community',
        },
        owner_user_id: {
          title: 'Owner',
        },
        lockerCompanies: {
          title: 'Marketing tags',
        },
        currency: {
          title: 'Currency',
        },
        default_phone_prefix: {
          title: 'Default phone prefix',
          description: 'Used in landing page URLs, to set in register page',
        },
        delivery_by_phone: {
          title: 'Delivery by phone',
        },
        description: {
          title: 'Description',
        },
        directory_deliveries_24: {
          title: 'DD24 multi',
        },
        directory_deliveries_25: {
          title: 'DD25',
        },
        directory_delivery: {
          title: 'Directory delivery',
        },
        gateCodes: {
          title: 'Gate entry codes',
        },
        identifier: {
          title: 'Identifier',
        },
        internal_delivery_type: {
          title: 'Internal delivery (OBS)',
        },
        la_liga: {
          title: 'La Liga'
        },
        languages: {
          title: 'Languages',
        },
        last_ping: {
          title: 'Last synchronized',
        },
        location_info: {
          title: 'Location info',
        },
        location_description: {
          title: 'Description of exact location',
        },
        location_building_name: {
          title: 'Building name',
        },
        location_building_floor: {
          title: 'Floor',
        },
        locker23_feature: {
          title: 'Locker23 design',
        },
        logo_image_id: {
          title: 'Custom logo',
          imageHint: 'The image should be of 350x70 pixels and transparent PNG',
        },
        machine_number: {
          description: "Insert machine number DM-XXXX here.",
          title: 'Machine number',
        },
        only_local_delivery: {
          title: 'Only local delivery',
          description: 'delivery only to locker users',
        },
        os_version: {
          title: 'OS Version',
        },
        os_memory: {
          title: 'Memory',
        },
        os_cpu: {
          title: 'Cpu',
        },
        should_send_reminders: {
          title: 'Pickup reminders',
          description: 'Controls if pickup reminders are sent for orders in this Smart Point',
        },
        sim: {
          title: 'SIM Identifier',
          saved: 'SIM code saved',
        },
        status: {
          title: 'Status',
        },
        theme_name: {
          title: 'Theme (OBS)',
        },
        version: {
          title: 'Version',
        },
        vertical: {
          title: 'Vertical',
          values: {
            10: 'Corporate',
            20: 'Office',
            30: 'Hospital',
            40: 'Residential',
            50: 'Student',
            60: 'Bespoke',
          },
        },
        landing_version: {
          title: 'Landing version',
          values: {
            100: 'Single tenant',
            110: 'Multi tenant',
          },
        },
        screen_type: {
          title: 'Screen type',
          applied: 'Applied',
          notApplied: 'Not applied',
          values: {
            big: 'Big screen',
            small: 'Small screen',
          },
        },
        zone_id: {
          title: 'Zone',
        },
      },
      create: {
        title: 'New Smart Point',
      },
      laLiga: {
        errors: {
          end_at: {
            future_date: 'Shall be a future date',
          },
          start_at: {
            max_today: 'Shall be today or before',
            within_past_6_months: 'Max past 6 months',
          },
        },
        fields: {
          endAt: {
            title: 'Ends at',
          },
          startAt: {
            title: 'Starts at'
          },
        },
        title: 'La Liga!',
      },
      landingPages: {
        removeConfirmationDialog: {
          title: "Remove company from this Smart Point?",
          description: "The landing page will also stop working",
        },
        title: 'Landing pages',
        titles: {
          10: 'Departments',
          20: 'Companies',
          30: 'Departments',
          40: 'Flats',
          50: 'Flats',
          60: 'Flats',
        },
        unassignedCount: "Users connected / not connected",
      },
      logoImage: {
        errors: {
          image: {
            'exactWidth:350': 'not 350x70 pixels',
            'exactHeight:50': 'not 350x70 pixels',
          }
        },
        toastOK: 'Don\' forget to push configuration!',
      },
      module_name: {
        _: 'THESE ARE MODULE TYPE TRANSLATIONS, DO NOT PUT MODULE NAME TRANSLATIONS HERE',
        1: 'Máster',
        2: 'Tintorería',
        3: 'Paq',
        4: 'Mix',
        5: 'Master (Z)',
        6: 'Paq (Z)',
        7: 'Mix (Z)',
        8: '5 comp (Z)',
        9: '11 comp (Z)',
        10: '8 comp (Z)',
        11: '7 comp (Z)',
        12: '6 comp (Z)',
        13: '4 comp (Z)',
        14: 'Master +2 (Z)',
        15: 'Master +3 (Z)',
        16: 'Master +4 (Z)',
        17: '10 comp (Z)',
        18: '9 comp (Z)',
        19: '3 comp (Z)',
        20: 'Master +7 (Z)',
        21: '9 comp XL (Z)',
        22: '4 comp (Z)',
        23: '10 comp XL/A (Z)',
        24: '10 comp XL/B (Z)',
        25: '12 comp A (Z)',
        26: '16 Mix (Z)',
        27: '14 Mix (Z)',
        28: '10 Mix Double (Z)',
        29: '15 Mix Double (Z)',
        30: '12 Mix Double (Z)',
        31: '10 Mix comp (Z) ',
        89: 'Totem/screen',
        99: 'Unknown',
      },
      pushConfiguration: {
        title: 'Push configuration',
        confirmationLabel: 'Confirmation (enter machine number)',
      },
      qr: {
        fields: {
          preset: {
            title: 'Choose preset:',
          },
          utmCampaign: {
            title: 'UTM campaign',
          },
          utmMedium: {
            title: 'UTM medium',
          },
          utmSource: {
            title: 'UTM source',
          },
          registerLanding: {
            title: 'Show QR on locker',
          },
        },
        title: 'QR generator',
        utm: {
          onboarding: {
            title: 'Onboarding Materials',
            campaignName: 'Onboarding',
            // sources: source: title tuples
            sources: {
              vinilo: 'Vinilo',
              flyer: 'Flyer',
              'Roll Up': 'Roll Up',
              Screensaver: 'Screensaver',
              Posters: 'Posters',
              Stickers: 'Stickers',
              'Table tents': 'Table tents',
            },
          },
          welcomePack: {
            title: 'Welcome Pack Materials',
            campaignName: 'welcomepack',
            sources: {
              Flyers: 'Flyers',
              'Screen saver': 'Screen saver',
              Poster: 'Posterl',
              'Roll up': 'Roll Up',
            },
          },
          campaign2: {
            title: 'Campaign 2',
            campaignName: 'welcomepack',
            sources: {
              'Flyers':	'Flyers',
              'Screen saver':	'Screen saver',
              'Poster':	'Posterl',
            },
          }
        },
      },
      reboot: {
        title: 'Reboot machine',
        description: '¿Are you sure to reboot this machine?',
      },
      statuses: {
        title: 'Status',
        deleted: 'Deleted',
        online: 'Online',
        install: 'In install',
        off: 'Offline',
      },
      edit: {
        title: 'Edit Smart Point',
      },
      title: 'Smart Point',
    },
    nav: {
      details: 'Details',
      edit: 'Edit',
      cells: 'Cells',
      serviceProviders: 'Providers',
      orders: 'Orders',
      contracts: 'Contracts',
      transfer: 'Transfer',
      screensavers: 'Screensavers',
      landingpages: 'Landing pages',
    },
    lockers: {
      search: 'Search in name, address, version, status',
      csvExportHint: 'Downloads a CSV with all Smart Points matching the current filters.',
      csvLimitTitle: 'Row limit reached',
      csvLimitText: 'You are trying to download more than 1000 Smart Points, which is the maximum limit. Apply filters to narrow down the results.',
      fields: {
        counts: {
          title: 'SP / SS',
          hint: 'service providers / screensavers',
        },
        last_sync: 'Last ping',
        machine: 'Machine',
        os_version: 'OS',
        os_memory: 'Cpu / Memory',
        version: 'Version',
      }
    },
    standalone: {
      title: 'Digital portals of: ',
    },
    screensavers: {
      enable_desc: 'This screensaver will be enabled on all Smart Points. Continue?',
      disable_desc: 'This screensaver will be disabled on all Smart Points. Continue?',
    },
    transfers: {
      title: 'Transfer destinations',
      create: 'Add transfer destination',
    },
  },
  lockersProviders: {
    title: 'Service providers on SmartPoint',
    titleOnLocker: 'on SmartPoints',
    titleOnCommunity: 'on communities',
    descriptionOnLocker: 'See lockers where this provider is available',
    showAllServiceProviders: 'All Sp',
    communityRestricted: 'This provider is restricted to specific communities and cannot be assigned to this locker',
    channelInconsistency: 'Channel inconsistency between community and this service provider',
  },
  login: {
    title: 'Access',
    email: 'Email',
    password: 'Password',
    submit: 'Enter',
  },
  menu: {
    title: 'Toolbar',
    panel: {
      title: 'Panel',
    },
    orders: {
      title: 'Orders',
      list: 'List',
      create: 'New Order',
      single: 'Single orders',
    },
    subscriptions: {
      title: 'Subscriptions',
    },
    routes: {
      title: 'Routes',
      list: 'List',
      create: 'New route',
    },
    operations: {
      title: 'Operations',
    },
    invoices: {
      title: 'Invoices',
      list: 'List',
    },
    users: {
      title: 'Users',
      list: 'List',
      details: 'Details',
      orders: 'Order history',
      promotions: 'Promos',
      communications: 'Communications',
      addresses: 'Addresses',
      permissions: 'Permissions',
    },
    userImport: 'Diffusion platform',
    diffusionExpress: 'Diffusion express',
    standalone: {
      title: 'Digital portals',
    },
    standalones: {
      title: 'Digital portals',
    },
    amenities: {
      title: 'Amenities',
      list: 'List',
      metrics: 'Monthly Metrics',
    },
    clients: {
      title: 'Clients',
      list: 'List',
      create: 'Create',
    },
    communities: {
      title: 'Communities',
      list: 'List',
      create: 'Create',
      securityCodes: 'Security Pins',
    },
    providers: {
      title: 'Providers',
      list: 'List',
      details: 'Details',
      lockers: 'On Smartpoints',
      categories: 'Categories',
      timeline: 'Logs',
      services: 'Services',
      promotions: 'Promotions',
      metrics: 'Monthly Metrics',
      products: 'Products',
    },
    lockers: {
      title: 'Lockers',
      install: 'Install',
      list: 'List',
      details: 'Details',
      edit: 'Edit',
      packagesToTransfer: 'Packages to transfer',
      providers: 'Providers',
      screen_savers: 'Screensavers',
      contracts: 'Contracts',
      cells: 'Cells',
    },
    webhooks: {
      title: 'Webhooks',
    },
    reports: {
      title: 'Reports',
      general: 'General reports',
      datastudio: 'Datastudio reports',
      registrations: 'User registrations',
    },
    companies: {
      title: 'Companies',
    },
    helpdesk: {
      title: 'Helpdesk',
      dashboard: 'Dashboard',
      inbox: 'Inbox',
      accounts: 'Gmail Accounts',
      tickets: 'Tickets',
      spam: 'Spam Filter',
      ticketTypes: 'Ticket Types',
      sentEmails:  'Sent Emails',
      templates:   'Templates',
      signatures:  'Signatures',
      whatsapp:    'WhatsApp',
    },
    settings: {
      channels: 'Channels',
      modules: 'Modules',
      title: 'Settings',
      translations: 'Translations',
      messages: 'Messages',
      identityIntegrations: 'Identity Integrations',
      deliveries: 'Deliveries',
      themes: 'Themes',
      landings: 'Landing pages',
      holidays: 'Holidays',
      zones: 'Zones',
      couriers: 'Couriers',
    },
    permissions: {
      title: 'Permissions',
      permissionMap: 'Permission map',
      whoHas: 'Who has...',
    },
    swagger: {
      title: 'Swagger',
      module: 'Swagger/Modulo',
    },
    sshconnection:{
      title: 'SSH Connections',
      module: 'SSH Connections',
    },
    apiKeys: {
      title: 'API Keys',
      module: 'API Keys',
    },
    auditLogs: {
      title: 'Audit Logs',
      module: 'Audit Logs',
    },
    my_permissions: {
      title: 'My permissions',
    },
    logout: {
      title: 'Logout',
    },
    rentback: {
      title: 'Rentback',
      nextMonth: 'next month',
    },
  },
  subscriptions: {
    list: {
      plan:                 'Plan',
      amount:               'Amount',
      currentPeriodEnd:     'Period end',
      canceledAt:           'Canceled at',
      ordersCount:          'Orders',
      stripeSubscriptionId: 'Stripe ID',
      viewOrders:           'Orders',
      cancel:               'Cancel',
      retry:                'Retry payment',
      reactivate:           'Reactivate',
      renew:                'Renew',
      confirmCancelText:    'The subscription will be canceled at the end of the current period. Continue?',
      confirmCancelTitle:   'Cancel subscription',
      confirmCancelConfirm: 'Confirm cancellation',
      action_cancel_ok:     'Cancellation scheduled successfully',
      action_retry_ok:      'Payment retry triggered successfully',
      action_reactivate_ok: 'Subscription reactivated successfully',
      action_renew_ok:      'Subscription renewed successfully',
      renewTitle:           'Renew subscription',
      renewText:            'A new subscription will be created in Stripe using the customer\'s saved payment method.',
      renewConfirm:         'Confirm renewal',
      renewAmount:          'Amount',
      billingCycleAnchor:   'Estimated first billing date',
      cancellationReason:   'Cancellation reason',
      renewedTo:            'Renewed to',
      parentSubscription:   'Parent',
      reactivateTitle:      'Reactivate subscription',
      reactivateText:       'A new subscription will be created in Stripe using the customer\'s saved payment method.',
      reactivateConfirm:    'Confirm reactivation',
      clearFilters:         'Clear filters',
      ordersModalTitle:     'Subscription orders',
      orderTotal:           'Total',
      orderType:            'Type',
      orderUser:            'User',
      orderLocker:          'Locker',
      orders:               'Orders',
      noOrders:             'No orders for this subscription',
      results:              'results',
      pause:                'Pause',
      resumeFromPause:      'Resume',
      pauseTitle:           'Pause subscription',
      pauseUntilReview:     'Until further review (indefinitely)',
      pauseUntilDate:       'Until a specific date',
      pauseResumeDate:      'Resume date',
      confirmPauseConfirm:  'Confirm pause',
      pauseText:            'Billing will be paused. No payments will be charged during the pause.',
      action_pause_ok:      'Subscription paused successfully',
      action_resume_pause_ok: 'Subscription resumed successfully',
      pauseResumesAt:       'Resumes on',
      pauseIndefinite:      'Paused indefinitely',
      pauseScheduled:       'Pausing at period end',
      refund:                         'Refund',
      refundTitle:                    'Refund subscription payment',
      refundTypeLabel:                'Refund type',
      refundTypeFull:                 'Full refund',
      refundTypePartial:              'Partial refund',
      refundAmountLabel:              'Amount to refund',
      refundActionLabel:              'After refund',
      refundActionRefundAndCancel:    'Refund and cancel subscription',
      refundActionRefundOnly:         'Refund only — keep subscription active',
      refundLastCharge:               'Last charge',
      refundAlreadyRefunded:          'Already refunded',
      refundAvailable:                'Refundable amount',
      refundInvoiceDate:              'Invoice date',
      refundConfirm:                  'Confirm refund',
      action_refund_ok:               'Refund processed successfully',
      viewRefunds:                    'Refunds',
      refundsHistoryTitle:            'Refund history',
      refundsHistoryEmpty:            'No refunds recorded for this subscription',
      refundsHistoryAction:           'Action',
      refundAndCanceledTag:           'Refunded + canceled',
      refundAmountMin:                'Amount must be greater than 0',
      refundAmountMax:                'Maximum refundable amount:',
    },
    statuses: {
      active:             'Active',
      trialing:           'Trialing',
      past_due:           'Past due',
      canceled:           'Canceled',
      unpaid:             'Unpaid',
      paused:             'Paused',
      incomplete:         'Incomplete',
      incomplete_expired: 'Expired',
    },
  },
  orderCreate: {
    title: 'New Manual Order',
    step1: {
      title: 'Select customer',
      searchUser: 'Search user by name, email or ID',
      searchPlaceholder: 'Type at least 3 characters (name, email or ID)…',
      noResults: 'No users found',
      selectedUser: 'Selected customer',
    },
    step2: {
      title: 'Select location',
      locationTypeLocker: 'Locker',
      locationTypeAddress: 'Customer address',
      selectLocker: 'Select a locker',
      noLockers: 'No accessible lockers',
      selectAddress: 'Select an address',
      noAddresses: 'This customer has no registered addresses',
      loadingAddresses: 'Loading addresses…',
    },
    step3: {
      title: 'Add services',
      noServices: 'No services available for this locker',
      addedServices: 'Services to include',
      service: 'Service',
      provider: 'Provider',
      price: 'Price',
      quantity: 'Qty',
      addService: 'Add a service',
      mandatoryLabel: 'Required services',
      genericArticle: 'Generic article',
      genericArticleAdd: 'Add generic article',
      genericArticleDescription: 'Description',
      genericArticlePrice: 'Custom price',
      genericArticleProvider: 'Provider',
      genericArticleMinCompartment: 'Minimum compartment size',
      genericArticleMinCompartmentRequired: 'The minimum compartment size field is required',
      genericArticleNoCompartment: 'No compartment',
      promoCode: 'Promo code (optional)',
      note: 'Internal note (optional)',
      initialStatusLabel: 'Initial order status',
      initialStatusPickup: 'Awaiting collection',
      initialStatusConfirm: 'Confirm order',
      initialStatusRequired: 'Select the initial order status',
      create: 'Create order',
    },
  },
  orders: {
    viewOrderDetails: 'View order details',
    order: {
      title: 'Order',
      statuses: {
        status_order_new: 'New',
        status_awaiting_customer_dropoff: 'Awaiting customer dropoff',
        status_order_awaiting_collect: 'Awaiting pickup',
        status_order_in_route_collect: 'In route to pick up',
        status_order_sp_collected: 'Picked up and in progress',
        status_order_in_progress: 'In progress',
        status_order_assembled: 'Order ready for dispatch',
        status_order_in_route_delivery: 'Ready and in route',
        status_order_sp_delivered: 'Delivered and in locker',
        status_order_completed: 'Completed',
        status_order_professional_search: 'Searching for professional',
        status_order_professional_confirmed: 'Professional confirmed',
        // not used at the moment
        status_order_delayed: '',
        status_order_sp_cancelled: '',
        status_order_client_cancelled: 'Cancelled by user',
        status_order_sp_rejected: '',
      },
      statusesShort: {
        status_order_new: 'New',
        status_order_completed: 'Completed',
        status_awaiting_customer_dropoff: 'Dropoff',
        status_order_awaiting_collect: 'Awaiting pickup',
        status_order_in_route_collect: 'Route/pickup',
        status_order_sp_collected: 'Picked up and in progress',
        status_order_in_progress: 'In progress',
        status_order_assembled: 'Assembled',
        status_order_in_route_delivery: 'Route/deliver',
        status_order_sp_delivered: 'Delivered',
        // not used at the moment
        status_order_delayed: '',
        status_order_sp_cancelled: '',
        status_order_client_cancelled: 'Cancelled by user',
        status_order_sp_rejected: '',
      },
      items: 'Items',
      status: 'Status',
      paymentStatus: 'Payment status',
      paymentStatuses: {
        status_payment_unpaid: 'Unpaid',
        status_payment_paid: 'Paid',
        status_payment_declined: 'Declined',
        status_payment_unpaid_invoice: 'Invoice unpaid',
        status_payment_paid_invoice: 'Invoice paid',
        notConfirmed: 'Awaiting confirmation',
      },
      forceStatus: {
        title: 'Force status manually',
        current: 'current',
        button: 'Update status',
      },
      admin_collect: {
        button: 'Admin collects order',
        collect: 'Collect order by Administrator',
        label: 'Collect information',
        hint: "Use this option when the client has given us the order by hand (clothes, etc)",
        min: 'minimum 10 characters',
      },
      types: {
        delivery_with_code: 'Package delivery',
        locker_order: 'Locker order',
        laundry_drop_go: 'Tintorería - drop n go',
        public_locker: 'Public locker',
        home_delivery: 'Home delivery',
        office_order: 'Office order',
        bizcocho_order: 'Bizcocho',
        internal_delivery_1: 'Internal delivery',
        drop_only: 'Drop/maintenance',
        amazon_return: 'Amazon returns',
        custom: 'Custom',
        unknown: '???',
        smart_drop: 'Smart drop',
        package_transfer: 'Package transfer',
        cascos: 'Storage',
        professional_service: 'Professional service',
      },
      orderList: {
        quickFilters: {
          title: 'Quick filters',
          filters: {
            awaiting_delivery: 'Awaiting pickup',
            payable: 'Payable',
            ready_delivery: 'Ready for collect',
            without_package: 'Exclude packages',
            future_orders: 'Future orders',
            rentback: 'Rentback',
            discount_code: 'Discount code',
            completed: 'Completed',
            delivered: 'In locker',
            in_locker_24h: 'In locker +24h',
            in_locker_72h: 'In locker +72h',
          },
        },
        csvExportHint: 'Downloads a CSV file with the orders matching the current filters. Limited to 1000 rows. Apply filters first to narrow down the results.',
        csvLimitTitle: 'Row limit reached',
        csvLimitText: 'You are downloading more than 1000 rows, which is the maximum limit. The CSV file will be incomplete and you will lose data. Please apply filters to narrow down the information you need before downloading.',
      },
      stats: {
        totalOrders: 'Total orders',
        byDay: 'Day',
        byWeek: 'Week',
        byMonth: 'Month',
        noData: 'No data for the selected period',
        today: 'Today',
        thisWeek: 'This W.',
        thisMonth: 'This month',
        last2Months: 'Showing last 2 months',
        lastYear: 'Showing last year',
        thisWeekFull: 'This week',
        thisMonthFull: 'This month',
        ordersLabel: 'orders',
      },
      dates: {
        active_from: 'Active from',
        created_at: 'Created at',
        due: 'Due at',
      },
      locker_code: 'Locker code',
      lockerCode: 'Locker code',
      noLockerCode: 'There is no cell/code assigned',
      confirmed: {
        label: 'Confirmation',
        values: {
          0: 'Not confirmed',
          1: 'Confirmed',
        },
      },
      created_at: 'Created',
      due: 'Due',
      sub_total: 'subtotal',
      vat: 'vat',
      grand_total: 'total',
      grandTotal: 'Total',
      delivery_costs: 'Delivery costs',
      promotion: 'Promotion',
      rentback: 'Rentback',
      pickedUpAt: 'Picked up',
      pendingPickupAgeTags: {
        over24h: '24h+',
        over72h: '72h+',
      },
      rating: {
        title: 'Rating',
      },
      details: {
        title: 'Details',
        printCTA: 'Print ticket',
        locker: 'Smartpoint',
      },
      print: {
        order: 'Order',
        created: 'Created',
        items: 'Items',
        service: 'Service',
        qty: 'Qty',
        price: 'Price',
        total: 'Total',
        notes: 'Notes',
        print: 'Print',
      },
      location: {
        title: 'Location',
        types: {
          locker: 'Smartpoint',
        },
        pickupLocation: 'Pickup location',
        deliveryLocation: 'Delivery location',
      },
      timeslot: {
        pickupTimeslot: 'Pickup time',
        deliveryTimeslot: 'Delivery time',
      },
      user: {
        title: 'Client',
      },
      services: {
        title: 'Services',
        titleSingular: 'Service',
      },
      history: {
        title: 'History',
      },
      communications: {
        title: 'Communications',
        contentDialogTitle: 'Message #',
        to: 'Recipient',
        type: 'Type',
        status: 'Status',
        createdAt: 'Sent at',
        content: 'Contents',
        silent: 'Without communications',
      },
      logs: {
        title: 'History',
        actions: {
          101: 'New order on locker',
          102: 'New package delivery',
          103: 'New order',
          104: 'Image uploaded',
          106: 'Order paid',
          115: 'Client deposited',
          121: 'Provider collected',
          122: 'Provider delivered',
          145: 'Customer picked up',
          146: 'Set destination',
          147: 'Transfer to home',
          150: 'Order deleted',
          160: 'Order finalized',
          161: 'Order silenced',
          181: 'Order rated',
          201: 'Charger (OBS)',
          300: 'Provider confirmed',
          310: 'Customer confirmed',
          330: 'Order assembled',
          331: 'Service processed',
          350: 'Cell assigned',
          501: 'Confirmation resent',
          629: 'Marked unpaid',
          700: 'Spike error',
          100300: 'CELL OPEN SENT TO SMARTPOINT',
        },
        fields: {
          a: 'adminId',
          c: 'charge',
          con: 'confirmed',
          cn: 'comment/note',
          cr: 'reason/note',
          em: 'error message',
          fp: 'firstPaid',
          lc: 'cellId',
          m: 'method',
          o: 'origin',
          olc: 'old cellId',
          ols: 'old status',
          r: 'rating',
          s: 'status',
          so: 'spike operation',
          t: 'total',
          tld: 'destination',
          u: 'userId',
          w: 'reason',
        },
      },
      notes: {
        title: 'Notes',
        fromAdmin: 'Note from admin, click icon to see admin user',
        fromUser: 'Clients note',
        addPlaceholder: 'Write a note...',
        addCTA: 'Save note',
      },
      image: {
        title: 'Associed image'
      },
      pickupCell: 'Pick up from this cell',
      deliveryCell: 'Delivery to this cell',
      channel_id: 'Channel',
      open_remote_cell: 'Open Cell',
      // buttons
      errors: {
        orderNotPaid: 'Cannot finalize unpaid orders',
      },
      CTA: {
        delete: {
          button: 'Delete',
          title: 'Mark order as deleted, retaining original data',
        },
        finalize: {
          button: 'Order complete',
          title: 'Finalize order, skipping any remaining steps and communications.',
        },
        confirm_professional_service: {
          button: 'Confirm Professional',
          title: 'Do you want to confirm the professional for this order?',
        },
        newLockerCell: {
          button: 'Change compartment',
          errorTitle: 'A compartment must be assigned manually.',
          title: 'Click to assign a different size compartment',
          noLockerNoCell: 'This order doesn\'t have a locker, cannot assign cell.',
        },
        pay: {
          button: 'Mark paid',
          title: 'Mark order as paid',
        },
        requestPickup: {
          button: 'Pending payment & awaiting pickup',
          title: 'Assign a locker cell and notify the customer the order is pending payment and awaiting pickup',
        },
        repeat: {
          button: 'Repeat',
          title: 'Repeat order once or periodically',
          dialogTitle: 'Repeat Order',
          firstDate: 'First date',
          frequency: 'Frequency',
          cnt: 'Number of repetitions',
          success: 'Orders created:',
          frequencies: {
            week: 'Weekly',
          },
        },
        resendConfirmation: {
          button: 'Send new confirmation',
        },
        unPay: {
          button: 'Mark not paid',
          title: 'Mark order not paid and remove previous cash payment (if any)',
        },
        openCell: {
          button: 'Open',
          title: 'Confirm to open the cell'
        },
        silence: {
          button: 'Silence order',
          title: 'Mark order as silent. No communications will be sent regarding this order. This cannot be undone.',
        },
      },
    professional_service: {
        price_section_title: 'Price',
        fields: {
          unit_type: 'Unit type',
          unit_amount: 'Unit amount',
          unit_price: 'Unit price',
        },
        one_time: 'One time',
        daily: 'Daily',
        weekly: 'Weekly',
        biweekly: 'Biweekly',
        monthly: 'Monthly',
        calculation_units: {
          hours: 'Hours',
          days: 'Days',
          m2: 'm²',
          rooms: 'Rooms',
          units: 'Units',
          people: 'People',
        },
        service_details_section: {
          title: 'Service details',
          fields: {
            subscription: 'Subscription',
            starting_date: 'Starting date',
            starting_hour: 'Starting hour',
            chosen_days: 'Chosen days',
            cancellation_date: 'Cancellation date',
            cancellation_time: 'Cancellation time',
            cancellation_reason: 'Cancellation reason',
            cancellation_text: 'Cancellation text',
            refund_percentage: 'Refund percentage',
            refund_amount: 'Refund amount',
            cancellation_reasons: {
              'unexpected_emergency': 'Unexpected emergency',
              'no_longer_needed': 'No longer needed',
              'another_provider': 'Chose another provider',
              'other': 'Other',
            },
            time_format: 'HH:MM',
            date_format: 'DD/MM/YYYY',
            date_future: 'The date must be in the future',
            date_required: 'The date is required',
            time_required: 'The time is required',
            date_future_maximum: 'The date must be within the next 2 months',
          },
        },
      }
    },
    promotion: {
      promo_code: 'Promo code',
      type: 'Type',
      value: 'Value',
      value_type: 'Value type',
      min_total: 'Minimum total of order',
      active: 'Available',
      types: {
        first_order: 'First order',
        one_time: 'One time',
        multiple_times: 'Multiple times',
      },
      valueTypes: {
        absolute: 'Total',
        percentage: 'Percentage',
      },
      origins: {
        mgm: 'Member get member',
        personal: 'Personal coupon',
        other: 'Public promotion',
      },
    },
    package_delivery: {
      title: 'For',
      cell: 'Cell',
      open_remote_cell: 'Open remote cell',
      courier: 'Courier',
    },
    search: {
      title: 'Search orders',
      hint: 'Order id, client name, Smart Point name, or direction',
    },
    services: {
      processed: 'Processed',
      name: 'What',
      quantity: 'Quantity',
      sub_total: 'Price',
      add: 'Add service',
      noItems: 'No services.',
      confirmed: 'Order confirmed — items cannot be edited.',
      deleteConfirm: 'Remove this service from the order?',
      addPriceHint: 'Leave blank to use default price',
      CTA: {
        assemble: {
          button: 'Order is assembled',
        },
        confirm: {
          button: 'Confirm order',
          title: 'Confirm and send pay note',
        },
        edit: {
          button: 'Edit services',
          title: 'Add or remove services',
        },
        add: {
          button: 'Add service',
        },
        releaseCell: {
          button: 'Release cell',
        },
        newCode: {
          button: 'New code',
        },
      },
    },
  },
  lockerCompanies: {
    createDialog: {
      title: "Create company",
      slug: "Slug",
      description: "Description",
    },
    errors: {
      image: {
        'exactWidth:330': 'Image size not 330*110',
        'exactHeight:110': 'Image size not 330*110',
      },
    },
    fields: {
      description: 'Company',
      image: "Logo image",
    },
    logs: {
      actions: {
        100: 'company created',
        110: 'company/landing added',
        111: 'company/landing removed',
      },
      headers: {
        company: 'Company',
      },
    }
  },
  realtime: {
    smallTalk: 'the big number is orders today so far, the numbers under: orders on past days up to same hour of day, and estimated target to reach today',
    smallTalkCont: 'orders of internal Smart Points and internal providers are excluded',
    smallTalk2: 'number of active Smart Points and users',
    lastMonth: 'MOM',
    lastYear: 'YOY',
    lastWeek: 'WOW',
    onlineLockers: 'Smart Points',
    target: 'target for today',
    title: 'Realtime Information',
  },
  screen_savers: {
    title_locker: 'Screensavers on SmartPoint',
    title_in_locker: 'on SmartPoints',
    title: 'Screensaver',
    logs: {
      title: "Screensavers logs",
      singleSsTitle: "Screensaver logs",
      actions: {
        100: 'create Screensaver',
        200: 'copy Screensaver',
        300: 'connect/disconnect',
        500: 'activate/deactivate',
        700: 'remove Screensaver',
      },
      orderType: 'Order Type',
      commissionRate: 'Commission Rate (%)',
      commissionType: 'Commission Type',
    },
    edit: {
      title: 'Edit Screensaver',
      createTitle: 'Create Screensaver',
      errors: {
        missingRequiredFields: 'You must complete these required fields',
        nameRequired: 'The name is required',
        fieldRequiredSuffix: ' is required',
        imageRequired: 'You must upload an image',
        serviceProviderRequired: 'You must select a service provider',
      },
    },
  },
  serviceProvider: {
    metrics: {
      title: 'Monthly Metrics',
      scopeSize: 'Scope (Users)',
      visit: 'Visit',
      purchaseIntent: 'Purchase Intent',
      orders: 'Orders',
      gmv: 'GMV (€)',
      commission: 'Commission',
      commissionValue: 'Commission Value (€)',
      closeMonth: 'Close Month',
      goToActivePeriod: 'Go to active period',
      monthClosedOK: 'Period closed successfully',
      periodOpen: 'Open',
      periodClosed: 'Closed',
      periodNotClosed: 'Not closed',
      periodPreview: 'Preview',
      readOnly: 'Read only',
      estimate: 'Estimate qty',
      enterValue: 'Enter value',
      incompleteWarning: '{count} service providers with missing data',
      confirmClose: {
        title: 'Close Month',
        text: 'This will lock all data for the selected period. This action cannot be undone.',
        confirm: 'Close Period',
      },
      orderTypes: {
        automatic: 'Automatic',
        b2b_account: 'B2B Account',
        partner_feedback: 'Partner Feedback',
        estimate: 'Estimated',
      },
      commissionTypes: {
        real: 'Real',
        estimated: 'Estimated',
        manual: 'Manual',
      },
      saveValidationError: 'All required fields must be filled before saving.',
      statusComplete: 'Complete',
      statusAwaitingValidation: 'Pending Validation',
      statusPending: 'No activity',
      statusIncomplete: 'Incomplete',
      closedMonthsOnly: 'You only have access to closed months. Navigate to a closed period to view data.',
      previousMonthData: 'Previous month data',
    },
  },
  standalones: {
    createDialog: {
      title: 'Create digital portal',
      text: 'A new digital portal will be created inside this locker, with an install code to link the physical device.',
      error: 'There has been an error while creating the digital portal',
      type: 'Device type',
    },
  },
  services: {
    provider: {
      nav: {
        details: 'Details',
        services: 'Services',
        products: 'Products',
        promotions: 'Promotions',
        lockers: 'In communities',
      },
      active: {
        confirmEnable: 'Enables this provider on all Smart Points',
        confirmDisable: 'Disables this provider on all Smart Points',
      },
      duplicate: {
        title: 'Duplicate, make a copy of the provider',
        text: 'Are you sure you want to duplicate ths Service provider',
        description: 'Copy the data of this sp to a new one',
        help: 'Thsi option will copy this service provider. It will duplicate all the data including services. ' +
          'note: it wont copy images, extensions nor user permissions',
        spLoadingError: 'Error loading the service provider data',
        spDuplicationOk: 'The Service Provider has been succesfully copied',
        buttonGo: 'Go to duplicated Service Provider',
      },
      delete: {
        confirm: 'Are you sure you want to delete this service provider? This action cannot be undone if there are no open orders.',
        errorOpenOrders: 'This service provider has open orders and cannot be deleted.',
      },
      categories: {
        title: 'Categories',
        values: {
          10: 'delivery (OLD)',
          20: 'food (OLD)',
          30: 'daily meal (OLD)',
          40: 'shop (OLD)',
          50: 'click-n-collect (OLD)',
          60: 'services (OLD)',
          70: 'one-click (OLD)',
          80: 'building services (OLD)',
          110: 'My building (OLD)',
          120: 'Services for Me (OLD)',
          130: 'Shops & Gifts (OLD)',
          140: 'Pets (OLD)',
          150: 'Food (OLD)',
          160: 'Experiences (OLD)',
          170: 'Health (OLD)',
          210: 'My building',
          220: 'Mobility',
          230: 'Kids',
          240: 'Pets',
          250: 'Food',
          260: 'Circular economy',
          270: 'Assistance',
          280: 'Parcel services',
          290: 'Lifestyle',
          300: 'Corporate',
        },
        noCategories: 'Without a category the provider won\'t show correctly in the app',
      },
      channels: {
        noChannel: 'At least one channel is required',
      },
      errors: {
        image: {
          'maxWidth:1900': 'Max width 1900px',
          'maxHeight:1425': 'Max height 1425px',
          'maxImageSize:614400': 'Maximum 600kb',
        },
      },
      professional_service_fields: "Professional Service configurations",
      professional_card: {
        subtitle: 'Pricing, availability and what the service includes',
        pricing_title: 'Pricing',
        pricing_desc: 'What the customer pays and how the service is measured',
        availability_title: 'Availability',
        availability_desc: 'When customers can book. Leave a field empty to use the default value.',
        scope_title: 'What is included',
        scope_desc: 'Shown to the customer before booking',
        working_days: 'Working days',
        no_working_days: 'No working days selected. Customers will not be able to book this service.',
        lead_days: 'Minimum notice',
        lead_days_hint: 'Days from today to the first bookable day, which starts at the opening time',
        max_days: 'Booking window',
        max_days_hint: 'How many days ahead customers can book',
        opening_hour: 'Opening time',
        closing_hour: 'Closing time',
        slot_minutes: 'Time slots',
        days_suffix: 'days',
        minutes_suffix: 'min',
        default_value: '{value} (default)',
        summary: 'Customers can book from today + {leadDays} days at {opening}, up to {maxDays} days ahead. Start times run from {opening} to {closing}, every {slot} min, on working days.',
        errors: {
          lead_days: 'Between 1 and 30 days, and fewer than the booking window',
          max_days: 'Between 2 and 365 days, and more than the minimum notice',
          opening_hour: 'Must be earlier than the closing time',
          closing_hour: 'Must be later than the opening time',
          slot_minutes: 'Choose 15, 20, 30 or 60 minutes',
        },
      },
      noIncludesOrExcludes: 'Please write what the service includes and excludes',
      scope: {
        title: 'Scope',
        hint: 'Defines the areas where this provider operates. It is independent of the office address.',
        country: 'Country',
        countryRequired: 'Scope country is required',
        cities: 'Cities',
        zipcodes: 'ZIP Codes',
        verticals: 'Verticals',
        selectCountryFirst: 'Select a scope country first',
        invalidZipcode: 'Invalid ZIP code for the selected country',
        filterExplanation: 'These settings are used for search & assign filters. If no scope is assigned, this provider will appear in all areas and/or verticals.',
      },
      fields: {
        howToTitle: 'Steps to use the service',
        instructions_1: 'step 1',
        instructions_2: 'step 2',
        instructions_3: 'step 3',
        hide_app_interface: "Hide interface in the app",
        urgency_tag: "Text for the incentive tag",
        urgency_tag_hint: "If an option in the incentive tag has been selected, this text will be used along the tag",
        infocard_cta_text: 'CTA button text (leave blank for default)',
        about_us: 'Description',
        address_line_2: '(continued)',
        address_postcode: 'Post code',
        address_town_city: 'City',
        address_county: 'County',
        address_country_id: 'Country',
        autoconfirm: 'Autoconfirm',
        delivery_address: 'Delivery address',
        display_locker: 'Display on locker',
        display_locker_or_digital_portal: 'Display on locker / Digital portal',
        suscription: 'Suscripction',
        subscription_card_title: 'Subscriptions',
        subscription_card_subtitle: 'Stripe subscription configuration',
        subscription_card_inactive: 'Inactive',
        subscription_advanced_config: 'Advanced subscription settings',
        billing_anchor_section: 'Billing cycle',
        billing_anchor_section_desc: 'Fixed billing day with optional cutoff window',
        billing_anchor_day: 'Billing day (1–28)',
        billing_anchor_day_hint: 'No value: immediate billing on signup',
        billing_cutoff_day: 'Cutoff day (1–28, optional)',
        billing_cutoff_day_hint: 'Late signup delays first charge by the configured number of cycles',
        billing_cycles_after_cutoff: 'Cycles to wait after cutoff',
        billing_cycles_after_cutoff_hint: 'Months from this month\'s anchor to the first charge (default: 2)',
        billing_anchor_preview: 'First charge if subscribed today',
        subscription_trial_section: 'Free trial',
        subscription_trial_section_desc: 'Free access period before first charge',
        subscription_trial_days: 'Free trial days',
        subscription_trial_days_hint: '"Trialing" status in Stripe — no charge until trial ends',
        subscription_trial_end_behavior: 'When trial ends without a card',
        subscription_trial_end_behavior_hint: 'Only if the customer has no saved payment method',
        subscription_trial_end_behavior_values: {
          cancel: 'Cancel the subscription',
          pause: 'Pause the subscription',
          create_invoice: 'Create invoice and wait for payment',
        },
        subscription_billing_section: 'Billing & proration',
        subscription_billing_section_desc: 'Proration, collection method and advanced settings',
        subscription_proration_behavior: 'Proration behavior',
        subscription_proration_behavior_hint: 'Period between signup and first billing day',
        subscription_proration_behavior_values: {
          none: 'No charge until billing date',
          create_prorations: 'Charge proportional to access period',
        },
        subscription_collection_method: 'Collection method',
        subscription_collection_method_hint: 'Applies to manual renewals from the backoffice',
        subscription_collection_method_values: {
          charge_automatically: 'Charge card automatically',
          send_invoice: 'Send invoice to customer',
        },
        subscription_days_until_due: 'Days until invoice due',
        subscription_days_until_due_hint: 'Days before the invoice is marked as overdue',
        subscription_payment_behavior: 'If first charge fails',
        subscription_payment_behavior_hint: 'Manual renewals only — checkout handles it automatically',
        subscription_payment_behavior_values: {
          default_incomplete: 'Incomplete — 23h window to pay',
          error_if_incomplete: 'Error — reject subscription creation',
          allow_incomplete: 'Permissive — activate even if charge fails',
        },
        subscription_automatic_tax: 'Automatic tax (Stripe Tax)',
        subscription_automatic_tax_hint: 'Requires Stripe Tax configured in the Stripe dashboard',
        stripe_discount_section: 'Stripe discount',
        stripe_discount_section_desc: 'Applied automatically to every one-off payment made with Stripe',
        stripe_discount_none: 'No discount',
        stripe_discount_note: 'On the Stripe checkout the customer sees the original price, the discount and the final total. Subscriptions are not discounted.',
        stripe_discount_type: 'Discount type',
        stripe_discount_type_hint: 'Leave empty to charge the full price',
        stripe_discount_type_values: {
          fixed: 'Fixed amount (€)',
          percentage: 'Percentage (%)',
        },
        stripe_discount_value: 'Discount',
        stripe_discount_value_hint: 'If the discount covers the whole order, the order is free and skips Stripe',
        stripe_discount_example: 'Example: on a {price} order the customer pays {total} (discount -{discount})',
        stripe_discount_example_free: 'Example: a {price} order is fully covered, so it is free and skips Stripe',
        service_price: "Service Price",
        calculation_unit: "Calculation Unit",
        calculation_unit_types: {
          hours: "Hours",
          days: "Days",
          m2: "Square meters",
          rooms: "Rooms",
          units: "Units",
          people: "People"
        },
        range_min: "Minimum Range",
        range_max: "Maximum Range",
        range: "Range",
        days_available: "Days Available",
        days_available_hint: "Number of days per year the service is available",
        service_includes: "Service Includes",
        service_includes_hint: "Description of what the service includes",
        service_excludes: "Service Excludes",
        service_excludes_hint: "Description of what the service does not include",
        days_of_week: {
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
        },
        has_item_tracking: 'Item tracking',
        invoicing_address: {
          title: 'Invoicing address',
          noAddress: 'Please provider an address'
        },
        link: {
          professional_title: 'Link for Budget or professional information',
          title: 'External link',
          titleWebviev: 'Webview link',
          hint_qr_bizcocho: 'How many times this link has been used in webapp',
          hint_qr_locker: 'How many times this QR link has been read on a Smart Point',
        },
        link_note: 'This link is only shown in the webapp, not in the locker',
        link_note_webview: 'This link is shown in the webview',
        phone_for_queries: {
          title: 'Phone to start orders, request quotes or ask questions about a service'
        },
        phone_for_queries_note: 'This phone will be shown in a banner both in the Locker and Bizcocho. If empty, no phone will be shown',
        name: 'Name (internal use, unique)',
        order_instructions: 'Order instructions',
        payment_provider: 'Payment provider',
        phone_number: 'Phone number',
        phone_number_mobile: 'Mobile number',
        primary_service_description: 'Name (for apps/clients)',
        send_communications: 'Send messages',
        tax_id_number: 'Tax number',
        tax_percentage: 'Tax percentage',
        uploads_enabled: {
          label: 'Upload shipping label',
          hint: 'When enabled, users will be asked to upload the shipping label',
        },
        precheck_url: 'Precheck URL',
        purchase_url: 'Purchase URL',
        integration_data: {
          label: 'Integration data (JSON object)',
          hint: 'Example: {"key": "value"}',
          invalid_json: 'Integration data must be a valid JSON object',
        },
        link_tracking: {
          section: 'Link tracking',
          section_desc: 'Identifiers added to the link when it is opened, so the partner can attribute conversions',
          preset: 'Destination',
          preset_hint: 'Who receives the identifiers and under which parameter names',
          presets: {
            none: 'None',
            impact: 'Impact (subId1 / subId2)',
            integrations_platform: 'Integrations Platform (u / c)',
            custom: 'Custom',
          },
          user: 'Parameter for the user ID',
          user_hint: 'Empty: the user ID is not sent',
          community: 'Parameter for the community ID',
          community_hint: 'Empty: the community ID is not sent',
          preview_app: 'App',
          preview_standalone: 'Standalone',
          note: 'Applies to the webview or infocard link. The app sends the user and the community; standalones only send the community, as they have no user.',
          developers_only: 'Only developers can change the link tracking.',
        },
        limited_to: {
          label: 'Limited to communities',
          hint: 'Select one or more communities',
        },
        use_only_restricted_cells: 'Use only restricted cells',
        website: 'Website',
        extensions: {
          values: {
            'request-callbacks': 'Request callbacks',
            'contact-and-questions': 'General contact/questions',
            'custom-order': 'Custom order',
            'drop-and-go': 'Drop & go available',
            // 'qr-codes': 'qr-codes',
            'quick-notes-urgent': 'Quick notes: urgent',
            'quick-notes-request-quote': 'Quick notes: request quote',
            'quick-notes-callback': 'Quick notes: please call me',
            // '24h': '24h',
          },
        },
        status: {
          label: 'Status',
          values: {
            '': '-',
            'new': 'new',
            'business': 'business',
            'flash': 'flash',
            'limited_edition': 'limited edition',
            '50pcnt': '50%',
            'exclusive': 'exclusive',
            'monday': 'lunes',
            'tuesday': 'martes',
            'wednesday': 'miercoles',
            'thursday': 'jueves',
            'friday': 'viernes',
          },
        },
        channel: {
          label: 'Channel',
          hint: 'The channel defines the service provider\'s payment method and currency.',
        },
        urgency_tag_type: {
          label: 'Incentive tag',
          explanation: 'This field shows incentive signs like: Discounts (Saving), Last units (Scarcity), Limited time (Urgency), Good reviews (Social Proof), Free Shipping (Less friction), New (Curiosity)',
          values: {
            [E_SERVICE_PROVIDER_TAG_TYPES.NO_TAG]: '-',
            [E_SERVICE_PROVIDER_TAG_TYPES.DISCOUNT_PERCENTAGE]: 'Discount',
          },
        },
        type: {
          label: 'Type',
          values: {
            amazon_return: 'Returns (amazon)',
            drop_only: 'Drop/maintenance',
            home_delivery: 'Home delivey',
            infocard: 'Infocard',
            infocard_sending: 'Infocard_sending',
            offline: 'offline',
            open_order: 'Open order',
            services: 'Services',
            supermarket: 'Supermarket',
            smart_drop: 'Smart drop',
            smart_storage: 'Smart storage',
            professional_services: 'Professional Services',
            webview: 'Webview',
          },
        },
        logo_image: {
          title: 'Logo',
          subtitle: 'used on locker and as default in app',
          noImage: 'The logo is required',
        },
        second_image: {
          title: 'Animation',
          subtitle: 'animation for app index',
        },
        brand_image: {
          title: 'Brand image',
          subtitle: 'replaces logo in app',
          noImage: 'The brand image is required',
        },
      },
      invoicing: {
        title: 'Invoicing',
        noAddress: 'The address is required for invoicing',
      },
      lockers: {
        title: 'On Smartpoints',
        description: 'On which Smartpoints is this provider available?',
      },
      noDescription: 'Please write a name and description for all the languages',
      onImageZoom: 'coming soon, for now right click on image and open in new tab',
      promotions: {
        title: 'Promotions',
        description: 'Promotions, make someone happy',
        add: 'Add Promotion',
        edit: 'Edit Promotion',
        delete: {
          confirm: 'Are you sure you want to delete this promotion?',
        },
        fields: {
          promo_code: 'Promo code',
          value: 'Value',
          value_type: 'Value type',
          expiration_date: 'Expiration date',
          min_total: 'Minimum total',
          notes: 'Notes',
          display_app: 'Show in app',
        },
      },
      search: 'Search in name, type, location',
      settings: 'Settings',
      serviceProvidersCategories: {
        title: 'Service providers in category',
        CTA_assign: 'assign',
        CTA_order: 'order',
      },
      serviceProvidersServices: {
        title: 'Services of:',
      },
      services: {
        title: 'Services of provider',
        description: 'Manage services of this provider',
      },
      users: {
        operator: 'operator',
        owner: 'owner',
      },
      where: 'On which Smart Points is this provider available?',
      which: 'Which providers are available on this Smart Point?',
      whichCommunity: 'Which providers are available in this community?',
    },
    services: {
      create: {
        title: 'Create Service',
      },
      edit: {
        title: 'Edit Service',
      },
      delete: {
        confirm: 'Are you sure you want to delete this service? This action cannot be undone.',
      },
      sections: {
        labels: 'Labels',
        pricingAndDetails: 'Pricing and details',
        tags: 'Tags',
        images: 'Images',
      },
      fields: {
        minimum_locker_cell_size_id: {
          label: 'Minimum cell size',
        },
        sale_price: {
          label: 'Sale price',
        },
        on_sale: {
          label: 'On sale price',
        },
        turnaround_time: {
          label: 'Turnaround',
        },
        short_description: {
          label: 'Short description',
        },
        description: {
          label: 'Description',
        },
        mandatory: {
          label: 'Delivery cost',
        },
        orderby: {
          label: 'Order',
        },
        tickets: {
          label: 'Tickets',
        },
        active: {
          label: "Is the service currently available at the ticket offices?",
        },
        tags: {
          label: 'Tags',
        },
        logo_file: {
          title: 'Logo',
          subtitle: 'Main image for the service',
          noImage: 'The logo is required',
        },
        second_logo: {
          title: 'Second image',
          subtitle: 'Secondary image for the service',
        },
      },
      errors: {
        image: {
          'maxWidth:1900': 'Max width 1900px',
          'maxHeight:1425': 'Max height 1425px',
          'maxImageSize:614400': 'Maximum 600kb',
        },
      },
    },
  },
  modules: {
    intro: 'Modules are the features a community can turn on. Submodules are the choices a community makes inside a module, such as its integration type.',
    create: 'New module',
    createTitle: 'New module',
    editTitle: 'Edit module',
    edit: 'Edit',
    save: 'Save module',
    saveFailed: 'The module was not saved. Check the fields and try again.',
    empty: 'No modules yet. Create the first one to offer it to communities.',
    communitiesCount: 'No communities | 1 community | {count} communities',
    communities: 'Communities',
    communitiesHelp: 'Communities that have this module turned on, with the submodule each one chose. Turn the module on or off in each community\'s Edit page.',
    searchCommunities: 'Search communities',
    noCommunityMatches: 'No community matches your search.',
    noCommunities: 'No community has this module turned on yet.',
    noPick: 'None chosen',
    fields: {
      name: 'Name',
      icon: 'Icon',
      iconHint: 'Shown on the module\'s tab in each community',
      changeIcon: 'Change icon',
      hideIcons: 'Hide icons',
      description: 'Description',
      slugHint: 'The identifier is created from the name and cannot be changed later',
      slugFixed: 'Identifier: {slug} (cannot be changed)',
    },
  },

  submodules: {
    title: 'Submodules',
    help: 'What a community can choose in this module\'s tab. Recorded for reference only.',
    add: 'Add submodule',
    save: 'Save submodule',
    editNamed: 'Edit submodule {name}',
    empty: 'No submodules yet, so communities have nothing to choose in this module.',
    pickedBy: 'Not chosen yet | Chosen by 1 community | Chosen by {count} communities',
    fields: {
      name: 'Name',
      description: 'Description',
    },
  },

  settings: {
    couriers: {
      tabs: {
        couriers: 'Couriers',
        catalog: 'Catalog by country',
      },
      fields: {
        name: 'Name',
        code: 'Code',
        codeHint: 'Unique identifier in snake_case, e.g. correos_express',
        codeInvalid: 'Use lowercase letters, numbers and underscores only (snake_case).',
        logo: 'Logo',
        logoHint: 'Recommended: 160px width x 80px height, 20px corner radius',
        logoAfterCreate: 'Save the courier first, then you can upload its logo.',
        countries: 'Countries',
      },
      create: {
        title: 'New courier',
      },
      edit: {
        title: 'Edit courier',
      },
      delete: {
        title: 'Delete courier',
        description: 'Courier "{name}" will be deleted and removed from every country catalog.',
      },
      catalog: {
        country: 'Country',
        selectCountry: 'Select a country to manage its couriers.',
        addCourier: 'Courier to add',
        add: 'Add',
        noCouriersToAdd: 'All couriers are already in this country',
        courierInactive: 'Courier inactive',
        moveUp: 'Move up',
        moveDown: 'Move down',
        remove: {
          title: 'Remove courier from country',
          description: 'Remove "{name}" from the {country} catalog?',
        },
      },
      toastSaved: 'Courier saved',
      toastDeleted: 'Courier deleted',
      errors: {
        code: {
          unique: 'This code is already used by another courier.',
          regex: 'Use lowercase letters, numbers and underscores only (snake_case).',
        },
        courier_id: {
          unique: 'This courier is already in this country.',
        },
      },
    },
    messages: {
      name: 'Message type',
      channel: 'Channel',
      loadError: 'Could not load messages',
      previewError: 'Could not load preview',
    },
    translations: {
      filter: 'Filter',
      incomplete: 'Incomplete only',
      key: 'Key',
      group: 'Group',
      item: 'Item',
      createTitle: 'Create translation',
    },
    permissions: {
      title: 'Permission map',
      codes: {
        0: 'No permission',
        1: 'Can access',
        2: 'Only from same channel',
        3: 'Only in development',
      },
      global: 'Global',
      permissions: {
        '1': {
          title: 'User permissions',
          description: 'Can assign and revoke permissions. Can edit permission map.',
          targetLabel: 'To give permission:',
        },
        '2': {
          title: 'Installer',
          description: 'People doing installations/maintenance',
        },
        '3': {
          title: 'Open remote cells',
          description: 'Only with this permission can one open cells in live. ONLY for action lockers/openCell',
        },
        '4': {
          title: 'Developer',
          description: 'Developer',
        },
        '10': {
          title: 'Administrator',
          description: 'Administrator',
        },
        '11': {
          title: 'Settings administrator',
          description: 'Can change global system settings',
        },
        '101': {
          title: 'SmartPoint owner',
          description: 'SmartPoint owner',
        },
        '102': {
          title: 'SmartPoint operator',
          description: 'SmartPoint operator',
        },
        '109': {
          title: 'Factory installer',
          description: 'Factory installer',
        },
        '110': {
          title: 'Internal delivery person',
          description: 'Internal delivery person',
        },
        '120': {
          title: 'Finance administrator',
          description: 'Can view and edit Smart Points\' finance data',
        },
        '201': {
          title: 'Channel administrator',
          description: 'Channel administrator',
        },
        '301': {
          title: 'Service Provider Owner',
          description: 'Service Provider Owner',
        },
        '302': {
          title: 'Service Provider Operator',
          description: 'Service Provider Operator',
        },
        '400': {
          title: 'Locker Company Receptionist',
          description: 'Locker Company Receptionist',
        },
        '500': {
          title: 'User import',
          description: 'Mass import from CSV file',
        },
        '501': {
          title: 'Diffusion express',
          description: 'Max diffusion from CSV file',
        },
        '520': {
          title: 'Dashboard permission',
          description: 'Access to Dashboard',
        },
        '600': {
          title: 'Order Webhook',
          description: 'Will recieve notifications about orders through the webhook',
        },
        '601': {
          title: 'User Webhook',
          description: 'Will recieve notifications about users (clients) through the webhook',
        },
        '901': {
          title: 'Driver OBS',
          description: 'Driver OBS',
        },
        '902': {
          title: 'Driver of Smart Point',
          description: 'Driver with access to some Smart Points',
        },
        '903': {
          title: 'Driver of channel',
          description: 'Driver with access to a whole channel',
        },
        '904': {
          title: 'Driver',
          description: 'Driver with read-only access to their routes',
        },
        '1001': {
          title: 'API/G1',
          description: 'API to register/log in users',
        },
        '701': {
          title: 'Marketing',
          description: 'Marketing role - access to promotions and providers management',
        },
        '702': {
          title: 'Product',
          description: 'Product role - access to promotions and providers management',
        },
        '703': {
          title: 'Operations',
          description: 'Operations role - access to communities management',
        },
        '1550': {
          title: 'API/H1',
          description: 'API to log in users (hormiguero)',
        },
      },
    },
    zones: {
      zone: 'Zone',
      create: {
        titlePopUp: 'Create zone',
        label: 'Name of new zone',
      },
      findByZone: 'Find by zone...',
      findZone: 'Find zone',
      lockersInZone: 'Smartpoints in this zone',
      restrictions: {
        title: 'Deliveries',
        dayOfWeek: 'Weekday',
        hour: 'Hour',
        types: {
          124: 'Daily delivery',
        },
      }
    }
  },
  sshconnections:{
    title: 'SSH Connections',
    list:{
        deviceId: 'Device ID',
        vps_ip: 'Server IP',
        vps_port: 'Server Port',
        tunnel_port: 'Tunnel Port',
        connectionstring: 'Connection string ',
        copysshconnectionstring: 'Copy SSH connection string to clipboard',
    }
  },
  identityIntegrations: {
    title: 'Identity Integrations',
    subtitle: 'External SAML identity providers allowed to authenticate Smart Point users',
    empty: 'No identity integrations yet',
    emptyFiltered: 'No integration matches these filters',
    saved: 'Changes saved',
    readOnly: 'Read only',
    notFound: 'This identity integration does not exist',
    backToList: 'Back to the list',
    filters: {
      search: 'Search',
      searchPlaceholder: 'Name, slug or issuer',
      clear: 'Clear filters',
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
    },
    tabs: {
      overview: 'Overview',
      connection: 'SAML connection',
      identity: 'Identity',
      activity: 'Activity',
    },
    tabHints: {
      connection: 'These values define the trust relationship with the identity provider. Changing them affects login immediately.',
      identity: 'How an assertion from this provider becomes a Smart Point user, and in which Community.',
      activity: 'What this integration has actually done, and every administrative change made to it.',
    },
    summary: {
      communities: 'Communities in scope',
      attributes: 'Mapped attributes',
      communityMappings: 'Community mappings',
      identities: 'Linked identities',
      checking: 'Checking the configuration…',
      checkFailed: 'The configuration could not be checked',
      readyToEnable: 'Ready to be enabled',
      readyToEnableHint: 'The configuration is complete. Enable it from the General card below.',
      notReady: 'Cannot be enabled yet',
      healthyActive: 'Active and correctly configured',
      healthyActiveHint: 'Users of the Communities in scope can authenticate through this provider.',
      brokenActive: 'Active, but its configuration would fail every login',
    },
    sections: {
      portalAccess: 'Portal access',
      general: 'General',
      authentication: 'Authentication',
      scope: 'Community scope',
      jit: 'JIT provisioning',
      attributeMapping: 'Identity attribute mapping',
      communityResolution: 'Community resolution',
      certificate: 'IdP certificate',
      identities: 'Linked identities',
      audit: 'Change audit',
    },
    actions: {
      enable: 'Enable',
      disable: 'Disable',
    },
    fields: {
      name: 'Name',
      slug: 'Slug',
      slugHint: 'Lowercase letters, digits and dashes only. E.g. my-partner',
      slugInvalid: 'Lowercase letters, digits and dashes only',
      protocol: 'Protocol',
      protocolReadOnly: 'Cannot be changed after the integration is created',
      uuid: 'UUID',
      uuidReadOnly: 'Stable identifier generated by the server',
      status: 'Status',
      issuer: 'Issuer (IdP entityID)',
      issuerHint: 'Must match exactly the Issuer the IdP sends in its SAML response',
      idpSsoUrl: 'IdP SSO URL',
      idpSsoUrlHint: 'Sign-in endpoint of the identity provider',
      spEntityId: 'SP Entity ID',
      spEntityIdHint: 'Smart Point identifier to register with the IdP',
      communities: 'Communities',
      jit: 'JIT provisioning',
      certificate: 'Certificate',
      linkedIdentities: 'Identities',
      notConfigured: 'Not configured',
      emailAttribute: 'Email attribute',
      emailAttributeHint: 'Name of the SAML attribute the email is read from. Empty disables it',
      urlInvalid: 'Must be an http or https URL',
    },
    canonicalFields: {
      external_subject: 'External subject',
      email: 'Email',
      first_name: 'First name',
      last_name: 'Last name',
      community_reference: 'Community reference',
    },
    canonicalFieldHints: {
      external_subject: 'Identifies the user for this integration. Never changes once identities are linked',
      email: 'Required for automatic linking and JIT provisioning',
      first_name: 'Optional. Only used when creating the user',
      last_name: 'Optional. Only used when creating the user',
      community_reference: 'Value the provider sends to identify the Community. Only used in attribute mapping mode',
    },
    attributeMapping: {
      hint: 'Every identity provider names these values differently. Say here what this one calls each of them. Leave a field empty to not read it at all.',
      source: 'Source',
      attributeName: 'SAML attribute',
      attributeNamePlaceholder: 'Name the provider sends',
      sources: {
        name_id: 'NameID',
        attribute: 'SAML attribute',
      },
      nameIdSelected: 'The external subject is taken from the SAML NameID. This is the default and what integrations used before attribute mapping existed.',
      communityReferenceUnused: 'Not in use yet: Community resolution is set to a fixed Community. Map it here first to be able to switch to attribute mapping.',
      communityReferenceRequired: 'Community resolution is set to attribute mapping, which needs this attribute: without it no login can resolve a Community.',
      communityReferenceRequiredActive: 'This integration is active, so the change cannot be saved until you fill it in or switch back to a fixed Community.',
      externalSubjectWarning: 'This integration has {0} linked identities. Changing the external subject means they will no longer be recognised.',
      confirmTitle: 'Change the external subject?',
      confirmBody: 'The {0} linked identities of this integration were saved with the current external subject. After this change they will no longer be recognised: depending on the configuration they will be linked again by email, created again by JIT, or rejected.',
      confirmNoMigration: 'Existing links are never rewritten automatically. There is no safe way to do it, so it must be done deliberately.',
      confirmAction: 'Change it anyway',
    },
    communityResolution: {
      hint: 'Which Community a login is provisioned into.',
      unsavedMode: 'Save the mode to be able to configure its mappings.',
      missingReferenceWarning: 'There is no attribute mapped to the Community reference. Without it no Community can be resolved and every login will fail.',
      modes: {
        fixed: 'Fixed Community',
        fixedHint: 'The only Community in the scope. Requires exactly one',
        attribute_mapping: 'Attribute mapping',
        attributeMappingHint: 'The Community is resolved from the value the provider sends',
      },
      mappingsTitle: 'Community mappings',
      addMapping: 'Add mapping',
      editMapping: 'Edit mapping',
      externalValue: 'External value',
      externalValueHint: 'Exactly as the provider sends it. It is compared literally',
      smartPointCommunity: 'Smart Point Community',
      communityHint: 'Only Communities within the scope of this integration',
      noScopedCommunities: 'The scope of this integration has no Community',
      searchExternalValue: 'Search by external value',
      noMappings: 'No mappings yet',
      removeTitle: 'Remove this mapping?',
      removeBody: 'Logins sending "{0}" will stop resolving to a Community and will be rejected.',
      removeKeepsUsers: 'Users already created through it are not affected.',
    },
    portalAccess: {
      hint: 'A PIN lets this partner open the developer portal and read the SAML documentation for their own integration. It is not a login to Smart Point and grants no access to any Community.',
      configured: 'PIN set',
      missing: 'No PIN',
      unreadable: 'Unreadable',
      missingAlert: 'This integration has no PIN, so nobody can open the portal on its behalf.',
      unreadableAlert: 'The stored PIN cannot be read. Replace it to restore access.',
      revealAction: 'Reveal PIN',
      hide: 'Hide',
      copy: 'Copy',
      dialogTitle: 'Portal PIN',
      dialogBody: 'Copy it now. Closing this dialog forgets it, and reading it again is a new request.',
      copyAndClose: 'Copy and close',
      copied: 'PIN copied',
      regenerateAction: 'Generate a new PIN',
      replaceLabel: 'New PIN',
      replaceHint: 'Set a PIN of your own instead of a generated one.',
      replaceAction: 'Replace PIN',
      revokeAction: 'Revoke PIN',
      regenerated: 'New PIN generated',
      replaced: 'PIN replaced',
      revoked: 'PIN revoked',
      confirmRegenerateTitle: 'Generate a new PIN?',
      confirmFirstBody: 'The PIN is shown once, right after it is generated. Copy it before leaving this page.',
      confirmReplaceTitle: 'Replace the PIN?',
      confirmReplaceBody: 'The current PIN stops working immediately. Anyone still using it loses access to the portal.',
      confirmRevokeTitle: 'Revoke the PIN?',
      confirmRevokeBody: 'The integration will no longer be able to open the developer portal. The SAML login is unaffected.',
    },
    create: {
      title: 'New identity integration',
      startsInactive: 'The integration is created inactive. You can enable it once the issuer, the SSO URL and the certificate are configured.',
      created: 'Integration created',
    },
    disable: {
      title: 'Disable this integration?',
      willStopAuthentication: 'Users will no longer be able to authenticate through this integration, effective immediately.',
      linksRemain: 'Existing identity links will remain stored.',
    },
    authentication: {
      hint: 'These values define the trust relationship with the identity provider. Changing them affects login immediately.',
    },
    scope: {
      hint: 'Removing a Community from the scope stops its users from authenticating through this integration. Existing identity links are not deleted.',
      emptyWarning: 'The scope is empty: this integration authenticates nobody.',
      saved: 'Scope updated',
    },
    jit: {
      hint: 'Creates the Smart Point user on first authentication when it does not exist yet.',
      noCommunityWarning: 'JIT is enabled but the scope has no Community, so no user will be provisioned automatically.',
      manyCommunitiesWarning: 'JIT is enabled and the scope has {0} Communities. Since a single Community cannot be determined, no user will be provisioned automatically.',
      noCommunityMappingWarning: 'JIT is enabled with attribute mapping but there is no mapping configured, so no Community can be resolved.',
      emailAttributeDisabled: 'Without an email attribute, trusted email extraction and email-based auto-linking are disabled.',
    },
    certificate: {
      hint: "The IdP's public signing certificate. Its contents are never displayed, only its fingerprint and metadata.",
      installed: 'Installed',
      missing: 'No certificate',
      invalid: 'Invalid',
      missingAlert: 'This integration has no certificate, so it cannot be enabled.',
      invalidAlert: 'The stored certificate cannot be parsed. Replace it to allow authentication.',
      fingerprint: 'SHA-256 fingerprint',
      subject: 'Subject',
      issuerDn: 'Issuer',
      validFrom: 'Valid from',
      validTo: 'Valid to',
      expired: 'Expired',
      replaceLabel: 'New certificate',
      replaceHint: 'Paste the certificate as PEM or base64. Only one certificate is supported: the new one replaces the previous.',
      replaceAction: 'Replace certificate',
      confirmTitle: 'Replace the certificate?',
      confirmBody: 'The SAML trust relationship changes immediately. Responses signed with the previous certificate will stop being valid.',
      replaced: 'Certificate replaced',
    },
    identities: {
      hint: 'Links between external identities and Smart Point users created by this integration.',
      empty: 'No linked identities yet',
      user: 'User',
      linkMethod: 'Link method',
      emailAtLinkTime: 'Email at link time',
      linkedAt: 'Linked at',
      methods: {
        existing: 'Existing user',
        verified_email: 'Verified email',
        jit: 'JIT',
      },
    },
    audit: {
      hint: 'Administrative changes to this integration configuration.',
      empty: 'No changes recorded yet',
      actionFilter: 'Change type',
      actions: {
        insert: 'Created',
        update: 'Updated',
        delete: 'Deleted',
      },
      unknownActor: 'Unknown',
      none: 'empty',
      noSafeFields: 'No displayable fields',
    },
    auditFields: {
      name: 'Name',
      slug: 'Slug',
      status: 'Status',
      protocol: 'Protocol',
      issuer: 'Issuer',
      idp_sso_url: 'IdP SSO URL',
      sp_entity_id: 'SP Entity ID',
      idp_certificate: 'Certificate (fingerprint)',
      jit_provisioning_enabled: 'JIT provisioning',
      email_attribute: 'Email attribute',
      attribute_mappings: 'Attribute mapping',
      community_mapping: 'Community mapping',
      community_resolution_mode: 'Community resolution',
      community_ids: 'Communities',
    },
    errors: {
      required: 'This field is required',
      unique: 'Already in use by another integration',
      regex: 'The format is not valid',
      in: 'The value is not supported',
      max: 'The value is too long',
      string: 'The value is not valid',
      url: 'Must be a valid URL',
      boolean: 'The value is not valid',
      exists: 'The selected Community does not exist',
      invalid: 'The value is not valid',
      issuerRequired: 'Enabling the integration requires the issuer to be configured',
      idpSsoUrlRequired: 'Enabling the integration requires the IdP SSO URL to be configured',
      certificateRequired: 'Enabling the integration requires a valid certificate',
      spEntityIdRequired: 'Enabling the integration requires the SP Entity ID to be configured',
      externalSubjectAttributeRequired: 'The external subject needs an attribute name when its source is a SAML attribute',
      emailMappingRequired: 'Attribute mapping requires the email attribute to be configured',
      communityReferenceMappingRequired: 'Attribute mapping requires the Community reference attribute to be configured',
      communityMappingsRequired: 'Attribute mapping requires at least one Community mapping',
      communityMappingOutOfScope: 'A Community mapping points at a Community outside the scope of this integration',
      externalSubjectMappingChangeRejected: 'This integration has linked identities. Confirm the change to apply it',
      status400: 'The request is not valid',
      status401: 'You are not allowed to do this',
      status403: 'You are not allowed to do this',
      status404: 'This integration no longer exists',
      status409: 'The change conflicts with the current state',
      status422: 'The change does not satisfy a precondition',
      status500: 'A server error happened',
      unexpected: 'An error happened',
    },
  },
  charts: {
    showTable: 'Table',
    showChart: 'Chart',
    day: 'Day',
  },
  auditLogs: {
    title: 'Audit Logs',
    subtitle: 'Every change recorded in the audit_logs table',
    noData: 'No audit log entries',
    emptyFiltered: 'No audit log entries match these filters',
    system: 'System / Queue',
    empty: '(empty)',
    softDeleteHint: 'User soft delete: the row was updated to anonymize the user (DELETED USER), not removed',
    actions: {
      insert: 'Insert',
      update: 'Update',
      delete: 'Delete',
    },
    fields: {
      id: 'ID',
      date: 'Date',
      type: 'Type (table)',
      action: 'Action',
      record: 'Record',
      recordId: 'Record ID',
      changedFields: 'Changed fields',
      changedBy: 'Changed by',
      ip: 'IP',
      userAgent: 'User agent',
    },
    filters: {
      title: 'Filters',
      all: 'All',
      allActions: 'All',
      authorPlaceholder: 'Search by name or email…',
      authorTooShort: 'Type at least 2 characters',
      authorNoResults: 'No user with audit entries matches',
      filterByThis: 'Filter by this value',
      periods: {
        always: 'Any time',
        today: 'Today',
        last7: 'Last 7 days',
        last30: 'Last 30 days',
        custom: 'Custom…',
      },
      search: 'Search',
      searchPlaceholder: 'Any text in the log data, user, IP…',
      period: 'Period',
      clear: 'Clear filters',
    },
    charts: {
      lastDays: 'last {days} days',
      totalCaption: 'in the last {days} days',
      dataFrom: 'Data as of {time} ({date})',
      cachedFor: 'Updates every {minutes} min',
      refresh: 'Refresh',
      clickHint: 'Click to list that day\'s rows',
      registered_users: {
        tab: 'Sign-ups',
        title: 'Registered users per day',
        unit: 'users',
        empty: 'No users registered in the last {days} days',
      },
      deleted_users: {
        tab: 'Deleted users',
        title: 'Deleted users per day',
        unit: 'users',
        empty: 'No users deleted in the last {days} days',
      },
      created_service_providers: {
        tab: 'New providers',
        title: 'Service providers created per day',
        unit: 'providers',
        empty: 'No service providers created in the last {days} days',
      },
      top_editors: {
        title: 'Top editors',
        subtitle: 'The {limit} users with the most changes in any table · last {days} days',
        centerCaption: 'changes',
        empty: 'No user made changes in the last {days} days',
        clickHint: 'Click a person to list their changes',
      },
    },
    detail: {
      recordHistory: 'History of this record',
      authorChanges: 'Changes by this user',
      changes: 'Changes',
      oldData: 'Old data',
      newData: 'New data',
      field: 'Field',
      before: 'Before',
      after: 'After',
      noChanges: 'This entry has no field data',
    },
  },
  apiKeys: {
    title: 'API Keys',
    subtitle: 'Manage external integrations\' access to the API',
    fields: {
      name: 'Name',
      status: 'Status',
      endpoints: 'Endpoints',
      lastUsedAt: 'Last used',
      neverUsed: 'Never used',
      noEndpoints: 'No endpoints assigned',
    },
    status: {
      active: 'Active',
      revoked: 'Revoked',
    },
    actions: {
      revoke: 'Revoke key',
    },
    empty: 'No API keys have been created yet',
    createModal: {
      title: 'New API key',
      endpointsLabel: 'Allowed endpoints',
      endpointsHint: 'Endpoints in this list are registered from the backend (routes + migrations); they can\'t be added from here.',
    },
    revealModal: {
      title: 'API key generated',
      warning: 'Copy this key now. It will not be shown again.',
      copied: 'Copied to clipboard',
      copy: 'Copy',
      headerHint: 'Send it in the X-API-KEY header of every request to a protected endpoint.',
    },
    revokeConfirm: {
      title: 'Revoke this API key?',
    },
    guide: {
      button: 'Usage guide',
      intro: 'Protecting a new endpoint takes two manual steps, on purpose: this way nobody protects (or unprotects) an endpoint by accident.',
      step1: {
        title: 'Middleware on the route',
        text: 'In the corresponding routes file (routes_modulo.php, routes_gmp.php, etc.) add the middleware with a slug as a parameter:',
        note: 'The slug is a free identifier you choose (the usual convention is something.something), but it can be any unique string.',
      },
      step2: {
        title: 'Migration that registers the slug in the catalog',
        text: 'A small migration (same pattern as add_api_keys_auth_management_permission_map.php) inserts a row into api_keys_auth_endpoints:',
      },
      runtime: {
        title: 'How it works at runtime',
        step1: 'The middleware reads the X-API-KEY header from the request.',
        step2: 'It computes its SHA-256 hash and looks for an active (non-revoked) key with that hash.',
        step3: 'It checks whether that key has been granted the endpoint whose slug matches the route.',
        step4: 'If everything checks out, the request goes through and last_used_at is updated. Otherwise: 401 (invalid/revoked key) or 403 (valid key without access to that endpoint).',
      },
      assignmentNote: 'The key ↔ endpoint assignment isn\'t touched by migrations: it\'s managed from this backoffice, by picking from the endpoint catalog when creating or reviewing a key.',
    },
  },
  standalone: {
    list: {
      installCode: 'Install code',
      demo: 'demo',
      deviceId: 'Device ID',
      deviceCode: 'Device code',
      lastPing: 'Last ping',
      health: 'Health',
        statuses: {
            title: 'Status',
            online: 'Online',
            off: 'Offline',
        },
      metrics: 'Metrics',
        logs_location: {
            title: 'Logs Location',
            volatile: 'Voaltile memory',
            persistent: 'Disk',
            auto: 'Automatic'
        },
        actions: {
            title: 'Actions',
            titles: {
                preview: 'Preview',
                reboot: 'Reboot device',
                screenshot: 'Screenshot',
                ssh: 'SSH Access',
                refresh: 'Refresh browser',
                markDemo: 'Mark as demo',
            }
        },
      deviceType: 'Device type',
      country: 'Country',
      search: 'Search by ID, install code, device ID, community, country',
      deleted: 'Deleted',
      showDeleted: 'Show deleted',
    },
    ssh:{
      titlePopUp: 'SSH Connection',
      descriptionPopUp: 'Request SSH Connection'
    },
    demo: {
      title: 'Mark as demo',
      description: 'Are you sure you want to mark it as demo?',
    },
    screenshot:{
      title: 'Standalone Screenshot',
      refresh: 'Request or refresh',
      requestSent: 'Request sent',
      waitingrefresh: 'Waiting to refresh:'
    },
    refresh:{
      title: 'Refresh browser',
      description: 'Refresh browser without restarting standalone',
    },
    detail: {
      title: 'Digital portal detail',
      saved: 'Changes saved',
      name: {
        title: 'Name',
      },
      sim: {
        title: 'SIM Identifier',
        saved: 'SIM code saved',
      },
      sections: {
        data: 'Data',
        management: 'Management',
      },
      delete: {
        hard: 'Delete permanently',
        soft: 'Delete (soft delete)',
        confirmHard: 'Are you sure you want to permanently delete this digital portal? This action cannot be undone.',
        confirmSoft: 'Are you sure you want to delete this digital portal? The device will be marked as deleted in the system.',
        success: 'Digital portal deleted',
      },
    },
  },
  timeSlots: {
    timeSlotRestrictions: {
      headers: {
        data: 'Content',
      },
      noRestrictions: 'Without restrictions',
      targets: {
        0: 'both',
        1: 'collect',
        2: 'deliver',
      },
      types: {
        10: {
          label: 'Hours',
          hint: 'Office hours when routes are done',
        },
        21: {
          label: 'Offset min.',
          hint: 'Don\'t offer slots within this time, eg. min 2 hours to collect',
        },
        22: {
          label: 'Offset min.',
          hint: 'Don\'t offer slots within this time, eg. min 2 days to deliver',
        },
        31: {
          label: 'Offset max.',
          hint: 'Don\'t offer slots out of this time, eg. max 24 hours to collect',
        },
        32: {
          label: 'Offset max.',
          hint: 'Don\'t offer slots out of this time, eg. max 7 days to deliver',
        },
        41: {
          label: 'Max per slot',
          hint: 'Limit number of orders within a slot',
        },
        42: {
          label: 'Internal',
          hint: 'Internal use',
        },
        123: {
          label: 'Holiday',
          hint: 'Holidays, when no routes are done',
        },
        124: {
          label: 'Zone',
          hint: 'Restrict zones',
        },
      },
    },
  },
  clients: {
    list: {
      title: 'Clients',
      create: 'New client',
    },
    detail: {
      title: 'Client',
      basicInfo: 'Basic info',
      contacts: 'Contacts',
    },
    edit: {
      title: 'Edit client',
    },
    create: {
      title: 'New client',
    },
    nav: {
      details: 'Details',
      edit: 'Edit',
      communities: 'Communities',
    },
    fields: {
      legalName: 'Legal name',
      principalContact: 'Principal contact',
      invoicingContact: 'Invoicing contact',
      contactHint: 'Enter the user ID',
    },
    stats: {
      communities: 'Communities (total)',
      lockers: 'Lockers (total)',
      standalones: 'Digital Portals (total)',
      users: 'Users (total)',
    },
  },
  communities: {
    nav: {
      list: 'List',
      details: 'Details',
      edit: 'Edit',
      lockers: 'Lockers',
      standalones: 'Digital Portals',
      invitationLinks: 'Invitation Links',
      contacts: 'Contacts',
      orders: 'Orders',
      serviceProviders: 'Providers',
      users: 'Users',
    },
    configuration: {
      notEnabled: 'This module is not enabled for this community.',
      enableIt: 'Enable it in Edit',
      discard: 'Discard changes',
      metadataOnly: 'Recorded for reference only. It doesn\'t switch anything on.',
      none: 'None',
      noneHelp: 'Nothing recorded for this community',
      regular: 'Regular',
      regularHelp: 'Smart Point\'s standard templates, through the channels you choose',
      custom: 'Custom',
      customHelp: 'The community\'s own notification templates, through the channels you choose',
      noCustomTemplates: 'The custom templates option is not set up yet',
      channels: 'Channels',
      chooseChannel: 'Choose at least one channel to save',
      chooseIntegrationType: 'Choose an integration type to save',
      communication: 'Communication',
      communicationHelp: 'How the community\'s events reach the partner. Optional.',
      labels: {
        default: 'Option',
        integrations: 'Integration type',
        notifications: 'Notification delivery',
      },
    },
    notifications: {
      standard: 'Standard template',
      custom: 'Custom template',
      loadFailed: 'The templates could not be loaded. Reload the page to try again.',
      channels: {
        email: 'Email',
        sms: 'SMS',
        push: 'Push',
      },
    },
    serviceProviders: {
      title: 'Providers',
      communityRestricted: 'This provider is restricted to specific communities and cannot be assigned to this community',
      channelInconsistency: 'Channel inconsistency between community and this service provider',
      assignedOK: 'The service {name} was assigned successfully',
    },
    users: {
      title: 'Users of',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      createdAt: 'Created at',
      active: 'Active',
      inactive: 'Inactive',
    },
    invitationLinks: {
      title: 'Invitation Links',
      copyTooltip: 'Copy code',
      copied: 'Code copied',
      deleteDisabledHint: 'Cannot delete an already used invite',
      fields: {
        code: 'Code',
        permission: 'Permission',
        usedBy: 'Status',
        usedByEmail: 'Used by',
      },
      permissions: {
        lockerOwner: 'Locker Owner',
        lockerOperator: 'Locker Operator',
      },
      status: {
        used: 'Used',
        unused: 'Unused',
      },
      createModal: {
        title: 'Create invitation link',
        permissionLabel: 'Permission level',
        implicitPermissionNote: 'In addition to the selected permission, permission 520 (Dashboard) will also be implicitly assigned.',
        noOnlineLockerWarning: 'This link is intended exclusively for B2B users of communities equipped with Lockers or Digital Portals. Sharing it with others may result in an incomplete interface experience.',
        noSendLink: 'I understand and want to proceed',
      },
    },
    list: {
      title: 'Communities',
      create: 'New community',
      csvExportHint: 'Downloads a CSV with all communities and their associated SmartPoints count.',
      csvLimitTitle: 'Row limit reached',
      csvLimitText: 'You are downloading more than 2000 communities, which is the maximum limit. Apply filters to narrow down the results.',
    },
    detail: {
      title: 'Community',
      basicInfo: 'Basic info',
      configuration: 'Configuration',
      location: 'Location',
      lockers: 'Associated lockers',
      rentbackRewards: 'Rent-back rewards',
      currentValues: 'Current values',
      financialData: 'Financial data',
      tabInfo: 'Info',
      tabFinancial: 'Financial',
      tabContacts: 'Contacts',
    },
    edit: {
      title: 'Edit community',
      softDelete: 'Soft delete',
      restore: 'Restore',
      deleteConfirmTitle: 'Delete community',
      deleteConfirmText: 'Are you sure you want to delete this community? You can recover it later.',
      restoreConfirmTitle: 'Restore community',
      restoreConfirmText: 'Are you sure you want to restore this community? It will remain inactive.',
    },
    create: {
      title: 'New community',
    },
    fields: {
      slug: 'Slug',
      slugHint: 'Leave empty to auto-generate from name',
      channel: 'Channel',
      invitationCode: 'Invitation code',
      currency: 'Currency',
      languages: 'Languages',
      locationName: 'Location name',
      locationLine1: 'Address line 1',
      locationLine2: 'Address line 2',
      locationCity: 'City',
      locationPostcode: 'Postcode',
      country: 'Country',
      coordinatesLat: 'Latitude',
      coordinatesLong: 'Longitude',
      nativeAppEnabled: 'Native app enabled',
      b2bCommunications: 'B2B Communications',
      b2bCommunicationsEnabled: 'B2B Communications enabled',
      rentback: 'Rentback',
      monthlyRentbackCredit: 'Monthly rent-back credit',
      rentbackEnabled: 'Rentback enabled',
      rentbackDisabled: 'Rentback disabled',
      rentbackCap: 'Order Credit',
      monthlyRentbackCap: 'Monthly order credit',
      clientType: 'Client type',
      clientTypes: {
        trial: 'Trial',
        live: 'Live',
      },
      useSecurityCode: 'PIN Code enabled',
      modules: 'Modules',
      modulesSubtitle: 'Select the module to enable the functionality',
      integrationType: 'Integration type',
      integrationsData: 'Notification templates',
      integrationsDataSubtitle: 'The template each channel sends to this community\'s users. Read only.',
      integrationsDataTemplate: 'Template',
      integrationsDataTranslationKey: 'Translation key',
      excludedModules: 'Exc. modules',
      includedModules: 'Inc. modules',
      client: 'Client',
      contractStartDate: 'Contract start date',
      contractEndDate: 'Contract end date',
      maintenanceFee: 'Maintenance fee',
      saasFee: 'SaaS fee',
      hardwareFee: 'Hardware fee',
      hardwareSalePrice: 'Hardware sale price',
      units: 'Units',
    },
    contacts: {
      title: 'Contacts',
      addContact: 'Add contact',
      role: 'Role',
      add: 'Add',
      email: 'Email',
      invalidEmail: 'Invalid email',
      noContacts: 'No contacts assigned',
      addedSuccess: 'Contact added successfully',
      deleteTitle: 'Remove contact',
      deleteConfirm: 'Are you sure you want to remove this contact?',
      roles: {
        asset_manager: 'Asset Manager',
        facility_manager: 'Facility Manager',
        marketing_manager: 'Marketing Manager',
        property_manager: 'Property Manager',
      },
    },
    status: {
      active: 'Active',
      inactive: 'Inactive',
      deleted: 'Deleted',
    },
    lockers: {
      address: 'Address',
      city: 'City',
      coordinates: 'Coordinates',
      machineNumber: 'Machine no.',
      version: 'Version',
      identifier: 'Identifier',
    },
    securityCodes: {
      title: 'Security Pins',
      pin: 'PIN Code',
      community: 'Community',
      generatePin: 'Generate PIN',
      createdBy: 'Created by',
    },
  },

  users: {
    dashboard: {
      details: 'Details',
      orders: 'Orders',
      expenditure: 'Expenditure',
      awaitingCollect: 'Awaiting collection',
      inProgress: 'In progress',
      completed: 'Completed',
      totalOrders: 'Total',
      outstanding: 'Outstanding',
      lastWeek: 'Last week',
      lastMonth: 'Last month',
      totalSpent: 'Total',
      remoteDelivery: 'Remote delivery',
    },
    communications: {
      title: 'Communications to',
    },
    details: {
      title: 'Details of',
    },
    export: {
      CTA: {
        label: 'Export',
        title: 'Download csv file of basic user data',
      },
    },
    orders: {
      title: 'Orders of',
    },
    promotions: {
      title: 'Promotions of',
      discount: 'Discount',
      usedPromotions: 'Promotions used',
      coupons: 'Coupons (used and available)',
      createCoupon: 'Personal coupon for',
    },
    search: {
      title: 'Search users',
      hint: 'name, email, phone, or user code',
      tooShort: 'keep typing...',
      noLuck: 'No luck',
    },
    user: {
      buttons: {
        resendChangePassword: 'Send Password change email',
        newDeliveryToken: 'New delivery code',
      },
      confirmSendPswEmail: {
        title: 'Send password change email',
        description: 'The email can take a few minutes to arrive'
      },
      confirmNewDeliveryToken: {
        title: 'Generate new delivery code',
        description: 'The current delivery code will stop working immediately'
      },
      fields: {
        accessible: {
          title: 'Comfort zone'
        },
        active: {
          title: 'Active',
        },
        advertising_consent: {
          title: 'Advertising consent',
        },
        company_name_for_billing: {
          title: 'Company name for billing'
        },
        created_at: {
          title: 'Registered at',
        },
        channel_id: {
          title: 'Channel',
        },
        delivery_token: {
          title: 'Delivery token '
        },
        email: {
          title: 'Email'
        },
        email_verified: {
          title: 'Email verified',
        },
        feature: {
          title: 'Feature',
          values: {
            0: '-',
            20: 'Bizcocho',
            1001: 'G1 API (OBS)',
          },
        },
        first_name: {
          title: 'Name',
        },
        internal_dept_name: {
          title: 'Department',
        },
        internal_delivery: {
          title: 'Internal Delivery'
        },
        internal_locker_id: {
          title: 'Smart Point',
        },
        invoice_payments: {
          title: 'Invoice payments',
        },
        invited_by: {
          title: 'Invited by:',
        },
        language_code: {
          title: 'Language',
        },
        last_name: {
          title: 'Last name'
        },
        last_logged_in: {
          title: 'Last logged in',
        },
        uses_native_app: {
          title: 'Mobile app',
        },
        locker_company_id: {
          title: 'Company or flat',
        },
        locker_id: {
          title: 'Smart Point ID'
        },
        role: {
          title: 'Role',
          values: {
            role_administator :'Administator',
            role_driver :'Driver',
            role_channel_administrator :'Channel Administrator',
            role_service_provider_owner :'Service provider owner',
            role_user_client :'Usual suspect',
            role_locker_owner :'Locker owner',
            role_service_provider_operator :'Service provider operator',
          },
        },
        phone_number: {
          title: 'Phone number',
        },
        phone_number_verified: {
          title: 'Phone number verified',
        },
        status: {
          helps: {
            user_registered: 'User registered through the landing page.',
            user_logged_in: 'User has logged in at least once.',
            package_received: 'User has already received a package. Package from user to user is not included.',
            order_made: 'User has already made an order.',
          },
          title: 'Status',
          user_registered: 'User registered',
          user_logged_in: 'User logged in',
          package_received: 'Package received',
          order_made: 'Order made',
        },
        spike_address_id: {
          title: 'ID',
        },
        spike_address: {
          title: 'Address',
        },
        spike_unit_number: {
          title: 'Unit number',
        },
        terms_and_conditions: {
          title: 'Terms and conditions',
        },
      },
      spikeInfo: {
        title: 'Spike V2 Address',
      },
      invoicing: {
        title: 'Invoicing',
      },
      personalInfo: {
        title: 'Personal Information',
      },
      logs: {
        title: 'History',
        actions: {
          10: 'Updated by Smart Point',
          11: 'Registered on Smart Point',
          12: 'Registered on Smart Point by new order',
          13: 'Updated profile in webapp (bizcocho)',
          16: 'Registered on webpage (obs)',
          17: 'Registered on landing page (obs)',
          18: 'Registered by order (backoffice)',
          21: 'Smart Point updated by a Smart Point order',
          22: 'Smart Point updated by backoffice order',
          23: 'Smart Point updated by register on Smart Point',
          24: 'Login',
          25: 'Login with remember me',
          26: 'Login by URL',
          101: 'Assigned new user code for a client',
          117: 'Imported users',
          118: 'Exported users',
          124: 'Migrated to another Smart Point',
          201: 'Received coupon MGM',
          202: 'Created coupon',
          203: 'Created zone',
          204: 'Created a new address for himself',
          205: 'Reset password email sent',
          206: 'Changed password',
        },
        origin: {
          0: '???',
          1: 'locker V3',
          2: 'locker V2',
          3: 'webapp (bizcocho)',
          4: 'sp landing page',
          10: 'API G1',
          20: 'importer',
          21: 'diffusion express',
          30: 'backoffice M1',
          40: 'manual',
        },
      },
      title: 'User',
    },
    userImport: {
      csv: {
        title: 'CSV file',
        placeholder: 'Select file to continue',
      },
      ignorePhone: {
        label: 'Ignore phone',
        hint: 'The phone column is neither read nor validated. Unchecked, the phone is required and must be a valid mobile.',
      },
      overrideLockerUsers: {
        label: 'Override locker users (Bayer / internal delivery only)',
        hint: 'For corporate lockers like Bayer: the CSV becomes the full list of SmartPoint users. New emails are created as users, residents not in the CSV are DEACTIVATED (not deleted nor anonymized) and those who come back are reactivated. No email is sent to anyone.',
        confirmTitle: 'Override locker users: deactivate residents not in the CSV',
        willDeactivate: '{count} of {total} active residents of {locker} will be deactivated. Only {matched} match the CSV:',
        massDeactivate: 'You are about to deactivate more than half of the SmartPoint residents. Check that the CSV and the SmartPoint are the right ones.',
        typeCount: 'Type {count} to confirm',
        nobody: 'There are no SmartPoint users to deactivate. The CSV will be processed anyway.',
        willRestore: 'previously deleted user(s) will be restored because they are back in the CSV:',
        notDeactivated: 'user(s) will not be deactivated because they have active orders:',
        lineErrors: 'CSV line(s) have errors and will not be processed',
        confirm: 'Import and deactivate',
      },
      operation: 'Operation',
      detail: 'Detail',
      operations: {
        invited: 'Invited',
        created: 'Created',
        moved: 'Updated',
        restored: 'Restored',
        unchanged: 'Unchanged',
        deactivated: 'Deactivated',
        notDeactivated: 'Not deactivated',
        notProcessed: 'Not processed',
        error: 'Error',
      },
      details: {
        invited: 'New user: invited to register',
        invitationSent: 'New user: invitation to register sent',
        invitationNotSent: 'New user: invitation NOT sent (test environment)',
        created: 'New user created (no email; they log in with "forgot my password")',
        movedFrom: 'Existing user moved from {community} / {locker}',
        noLocker: 'no SmartPoint',
        assigned: 'Existing user assigned to this SmartPoint (had none)',
        restored: 'Previously deleted user, restored',
        unchanged: 'Already belonged to this SmartPoint or its community',
        deactivated: 'Deactivated: not in the CSV',
        reactivated: 'User deactivated in this SmartPoint, reactivated',
        name_updated: 'Already in this SmartPoint or its community; name and surname updated from the CSV',
        alsoNameUpdated: 'name and surname updated',
        activeOrders: 'Not in the CSV, but has active orders',
        activeOrdersCount: 'Not in the CSV, but has {count} active order(s)',
        locker_not_available: 'This SmartPoint is not one you can manage',
        gate_codes_mismatch: 'Their current SmartPoint has different gate codes',
        phone_exists: 'The phone already belongs to another user',
        exception: 'Unexpected error processing the line',
        same_locker: 'Already in this SmartPoint',
        same_community: 'Already in another SmartPoint of the same community (not moved)',
        current_locker_not_available: 'Their current SmartPoint is not one you can manage',
        email_transport: 'The invitation email could not be sent (mail server error)',
      },
      delivery_token: 'Delivery Token',
      exampleLink: 'Download example CSV',
      line_number: 'Line',
      locker: {
        title: 'SmartPoint',
        placeholder: 'Choose SmartPoint to continue',
      },
      results: {
        all: 'All',
        existingUsersNote: 'Users that already existed do not get the CSV name, surname or phone: only their SmartPoint changes.',
        existingUsersOverrideNote: 'Users that already existed get the CSV name and surname; their phone is not changed.',
        invitationsNotSent: 'invitation(s) not sent because this is not the production environment. They are sent in production.',
        cntErrors: 'error(s) found',
        cntImported: 'user(s) OK',
        cntUpdated: 'user(s) updated SmartPoint',
        notModifiedCnt: 'user(s) not modified',
        restoredCnt: 'user(s) restored',
      },
      resultCode: {
        0: 'Header OK',
        10: 'Unknown error',
        11: 'File format not recognized',
        12: 'No data in the file',
        13: 'Error in header - please use the example file as template. Headers and columns must be the same.',
        100: 'Missing data (column) in this line',
        101: 'Processed OK',
        102: 'SmartPoint updated',
        103: 'User exists, not modified',
        104: 'Not possible to update',
        105: 'Phone number exists (registered already)',
        106: 'User restored',
        107: 'Will be restored',
        120: 'Max 1000 users per run. You can load again the same file to continue',
        130: 'Processed',
        199: 'Not processed',
        201: 'Email not valid',
        202: 'First name empty',
        203: 'Last name empty',
        204: 'Phone empty or not valid (must be a mobile)',
        254: 'Phone not valid',
        150: 'Deactivated (not in the CSV)',
        151: 'Will be deactivated (not in the CSV)',
        152: 'Not deactivated: has active orders',
        153: 'Not deactivated: deactivation failed and nobody was deactivated',
        160: 'Valid line (will be created, moved or reactivated)',
        161: 'Valid line (already a resident)',
      },
      resultTitle: 'Results',
      resultImported: 'Result',
      title: 'Diffusion platform',
      upload: 'Upload and import!',
    },
    userList: {
      id: 'Identifier',
      firstName: 'Name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      createdAt: 'Registered',
      usesNativeApp: 'Mobile app',
    },
    userPermissions: {
      title: 'Permissions of',
      cannotEditOwn: 'You cannot edit your own permissions',
      fields: {
        permission: 'Permission',
        target: 'Target',
        granted_by: 'Granted by',
        from: 'Since',
      },
      create: 'New permission for',
      whoHas: {
        title: 'Who has...',
      }
    },
    nav: {
      general: 'Details',
      edit: 'Edit',
      orders: 'Order history',
      communications: 'Communications',
      promotions: 'Promos',
      addresses: 'Addresses',
      mgm: 'MGM',
      permissions: 'Permissions',
      oldBackoffice: 'Old backoffice',
      oldBackofficeBadge: 'TEMPORARY',
      auditLogs: 'Audit Logs',
    },
    auditLogs: {
      title: 'Audit Logs',
      noData: 'No audit log entries for this user',
      system: 'System / Queue',
      fields: {
        date: 'Date',
        action: 'Action',
        changedFields: 'Changed fields',
        changedBy: 'Changed by',
        ip: 'IP',
      },
    },
    userEdit: {
      title: 'Edit user',
      invoiceEmails: 'Invoice emails',
      invoiceEmailsHint: 'Type an email and press Enter to add',
      adminSection: 'Admin settings',
      passwordSection: 'Password',
      password: 'New password',
      passwordConfirmation: 'Confirm password',
      passwordHint: 'Leave empty to keep current password',
      confirmPhone: 'Confirm phone number (override validation)',
      deleteDialog: {
        title: 'Delete user',
        description: 'This action will anonymize the user data. This cannot be undone easily.',
        confirmLabel: 'Type "delete" to confirm',
        confirmHint: 'Accepted: delete, borrar, esborra',
      },
    },
    mgm: {
      title: 'Member Get Member',
      invitedBy: 'Invited by',
      usersInvited: 'Users invited',
      notInvited: 'This user was not invited by anyone',
      noInvitations: 'This user has not invited anyone',
      fields: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        registered: 'Registered',
      },
    },
    addresses: {
      title: 'Addresses of',
      create: 'New address',
      createTitle: 'Create address',
      editTitle: 'Edit address',
      deleteTitle: 'Delete address',
      deleteConfirm: 'Are you sure you want to delete this address?',
      billing: 'Billing',
      delivery: 'Delivery',
      setDefaultBilling: 'Set as default billing address',
      unsetDefaultBilling: 'Remove as default billing address',
      setDefaultDelivery: 'Set as default delivery address',
      unsetDefaultDelivery: 'Remove as default delivery address',
      fields: {
        name: 'Name',
        address: 'Address',
        line_1: 'Address line 1',
        line_2: 'Address line 2',
        city: 'City',
        postcode: 'Postcode',
        country: 'Country ID',
        phone: 'Phone',
        type: 'Type',
        accessCode: 'Access code',
      },
      types: {
        residential: 'Residential',
        commercial: 'Commercial',
      },
    },
  },
  webhooks: {
    action: 'Action',
    created_by: 'Created by',
    createDialog: {
      title: "Create new webhook",
      url: "URL",
      action: "Scope",
      secret: {
        title: "Headers",
        placeholder: "Authorization: Bearer xxx\nConnection: keep-alive",
        hint: "'name: value'. Each newline is will be a new header. Name can't have spaces, between double quotes (\" char) nor between single quotes (' char)",
      }
    },
    errorDialog: {
      title: "Something happened",
      text: "Please contact with the administrator"
    },
    sampleCallCTA: 'Send sample call',
    title: 'Webhooks',
    titleOf: 'Webhooks of',
    webhook: 'Webhook',
  },
  routes: {
    list: {
      title: 'Delivery Routes',
      driver: 'Driver',
      start_address: 'Start address',
      end_address: 'End address',
      hops: 'Stops',
    },
    status: {
      in_delivery: 'In delivery',
      finished: 'Finished',
    },
    create: {
      title: 'Create Route',
      driver: 'Driver',
      city: 'City',
      channel: 'Channel',
      channels: 'Channels',
      starting_location: 'Starting location',
      starting_location_hint: 'Optional. Sets the route origin for leg A.',
      all_cities_hint: 'All cities included',
      smart_routing: 'Smart routing',
      auto_channels: 'Auto-assigned channels',
      no_channel_filter: 'No automatic channel filters',
      driver_filter_hint: 'Available channels for this driver are applied automatically.',
      all_cities: 'All cities',
      visible_orders: 'visible',
      selected_orders: 'selected',
      available_orders: 'Available orders',
      routed_orders: 'Orders in route',
      warning_order_tooltip: 'Order is unpaid or payment was declined, and it is ready for delivery or already on route.',
      no_orders_selected: 'Select orders from the table above to add them to the route.',
      order_count: 'order | orders',
      customer: 'Customer',
      location: 'Location',
      sp: 'Service provider',
      extra_stops: 'Extra stops',
      extra_stops_hint: 'Stops with no active order that the driver must still complete.',
      extra_stop_placeholder: 'Stop name...',
      add_extra_stop: 'Add extra stop',
      route_address_error: 'The route could not be calculated. Check that the extra stop addresses are valid and routable.',
      add_all: 'Add all',
      move_up: 'Move stop up',
      move_down: 'Move stop down',
    },
    edit: {
      title: 'Edit Route',
      visible: 'Visible',
      blocked: 'Blocked',
    },
    detail: {
      title: 'Route',
      driver: 'Driver',
      hops: 'Stops',
      legs_title: 'Route stops',
      waypoint: 'Stop',
      orders_on_leg: 'Orders',
      no_orders_on_leg: 'There are no orders assigned to this stop.',
      no_legs: 'No stops calculated.',
      orders_title: 'Orders on route',
      unassigned_orders_title: 'Orders not automatically assigned to a stop',
      not_found: 'Route not found.',
      direction_delivery: 'Delivery',
      direction_collect: 'Collection',
      destination_location: 'Destination location',
      order_document: 'Document',
      order_document_hint: 'Open associated document',
      extra_stop: 'Extra stop',
      extra_stop_badge: 'No order',
      mark_as_visited: 'Mark as visited',
      leg_visited: 'Stop visited',
      progress: '{visited} of {total} stops visited',
      next_stop: 'Next',
      go_to_next: 'Go to stop',
      all_visited: 'All stops visited',
    },
    delete: {
      title: 'Delete route',
      confirm: 'Are you sure you want to delete this route? Orders will return to their previous status.',
    },
    starting_locations: {
      title: 'Starting locations',
      add_title: 'Add starting location',
      add: 'Add location',
      name: 'Name',
      name_placeholder: 'e.g. Warehouse, Office...',
      search_address: 'Search address',
      find: 'Find',
      map_hint: 'Click on the map to set the starting point',
      empty: 'No starting locations saved yet',
      delete_confirm_title: 'Delete starting location?',
      no_maps_key: 'Google Maps API key is not configured.',
      maps_error: 'Could not load Google Maps.',
      geocode_error: 'Address not found.',
    },
    extra_stops: {
      title: 'Extra stop',
      name: 'Stop name',
      name_placeholder: 'e.g. Vinted point, Warehouse pickup...',
      search_address: 'Real address',
      map_hint: 'Search a real address or click on the map to set the stop',
      unnamed: 'Unnamed stop',
    },
  },

  products: {
    title: 'Products',
    newProduct: 'New product',
    editProduct: 'Edit product',
    viewApiDocs: 'View API docs',
    apiTitle: 'API — Products',
    apiAlert: 'Replace {token} with your access token. The user and community are resolved from the session context in b1.',
    createOrderTitle: 'Create one-time order',
    pending: 'pending',
    copy: 'Copy',
    copyId: 'Copy identifier',
    empty: 'No products',
    emptyHint: 'Create the first product using the button above',
    search: 'Search',
    serviceProvider: 'Service Provider',
    name: 'Name',
    description: 'Description',
    price: 'Price',
    type: 'Type',
    active: 'Active',
    inactive: 'Inactive',
    cancel: 'Cancel',
    save: 'Save',
    edit: 'Edit',
    deactivate: 'Deactivate',
    oneTime: 'One time',
    headers: {
      id: 'ID',
      provider: 'Provider',
      identifier: 'Identifier',
      name: 'Name',
      type: 'Type',
      price: 'Price',
      status: 'Status',
    },
  },

  reports: {
    users: {
      title: 'Users',
      description: 'User and behavior analysis',
    },
    lockers: {
      title: 'Lockers',
      description: 'Locker usage and statistics report',
    },
    ops_deliveries: {
      title: 'OPS - Deliveries',
      description: 'Operational delivery metrics',
    },
    landing_page: {
      title: 'Landing Page',
      description: 'Landing page performance and conversion',
    },
    amenities: {
      title: 'Amenities',
      description: 'Amenity usage statistics',
    },
    general: {
      title: 'General Reports',
      subtitle: 'Download operational data exports as CSV files.',
      startDate: 'Start date',
      endDate: 'End date',
      downloadCsv: 'Download CSV',
      downloadError: 'Download failed. Please try again.',
      advertisingConsent: {
        title: 'Advertising Consent Users',
        description: 'Export a list of users filtered by advertising consent status and channel.',
        channel: 'Channel',
        allChannels: 'All channels',
        consentGiven: 'Advertising consent',
        yes: 'Consent given',
        no: 'Consent not given',
      },
      lockerUptime: {
        title: 'Locker Uptime',
        description: 'Export locker uptime statistics for a given date range.',
        hint: 'Download includes uptime %, down events and interaction counts per locker.',
      },
      registrations: {
        title: 'User Registrations',
        description: 'Export sign-up counts per channel for a given date range.',
      },
    },
    registrations: {
      title: 'User registrations',
      loadError: 'Registrations could not be loaded. Please try again.',
      channel: 'Channel',
      signUps: 'Sign-ups',
      total: 'Total',
      monthly: {
        title: 'Monthly sign-ups per channel',
        subtitle: 'Last 12 months, including the current one.',
        totalCaption: 'sign-ups in 12 months',
        unit: 'sign-ups',
        month: 'Month',
        others: 'Others',
        empty: 'No sign-ups in the last 12 months',
      },
      period: {
        title: 'Sign-ups per channel in a period',
        subtitle: 'Number of users who signed up in each channel between both dates, inclusive.',
        search: 'Search',
      },
    },
  },

  rentbackSettings: {
    nextMonthNote: 'Changes will take effect on the 1st of the following month.',
  },
  helpdesk: {
    ticketStatus: {
      open:     'Open and in progress',
      pending:  'Pending external action',
      resolved: 'Resolved',
      closed:   'Closed/Invalid',
    },
    ticketStatusShort: {
      open:     'In progress',
      pending:  'External',
      resolved: 'Resolved',
      closed:   'Closed/Invalid',
    },
    dashboard: {
      weeklySub:   'Last 3 months, Monday to Sunday weeks · colour = current status of those tickets',
      weekOf:      'Week of {date}',
      weekCurrent: 'in progress',
      weekCreated: 'created',
      openTicketsSub: 'In progress or pending external action, newest first',
      kpiOpen:        'In progress',
      kpiOpenHint:    'Created in the last 3 months and being handled by the team',
      kpiPending:     'External action',
      kpiPendingHint: 'Waiting on someone outside the team (customer, supplier…)',
      kpiPendingNote: 'external action',
      kpiDone:        'Resolved and closed',
      kpiDoneHint:    'Tickets from the last 3 months already resolved, closed or marked invalid',
    },
    ticket: {
      goToEmail: 'Go to email',
      showMore:  'Show full email',
      showLess:  'Show less',
      newEmail:      'New',
      newEmailTitle: 'Arrived unread: marked as read when the ticket was opened',
    },
    tickets: {
      unreadLabel:      'Emails',
      unreadFilter:     'With unread replies',
      sortLabel:        'Sort',
      sortCreated:      'Created',
      sortLastEmail:    'Last email received',
      unreadBadge:      '{n} unread',
      unreadBadgeTitle: 'Emails in the ticket thread not read yet',
    },
    ticketCreate: {
      createType:  'Create type “{name}”',
      typeCreated: 'Ticket type “{name}” created',
      noTypes:     'Type to search or create a type',
    },
    inbox: {
      archive:     'Archive',
      unarchive:   'Unarchive',
      archived:    'Archived',
      archiveHint: 'Already reviewed: hidden from All and every other filter, shown only in Archived',
      reply: {
        title:              'Reply to {to}',
        to:                 'To',
        invalidEmail:       'Invalid email: {emails}',
        tooManyRecipients:  'Too many recipients: they cannot exceed 255 characters in total',
        includeHistory:     'Include the original message',
        includeHistoryHint: 'Quotes the email you are replying to, for anyone who has not seen the thread (e.g. the customer of a forwarded email)',
      },
      defaults: {
        title:       'Default filters',
        hintEmpty:   'Save the current filters and account to always see them when opening the inbox.',
        hintSaved:   'Your saved filters are applied when opening the inbox.',
        save:        'Save current filters as default',
        apply:       'Back to my default filters',
        clear:       'Remove default filters',
        saved:       'Default filters saved',
        cleared:     'Default filters removed',
        saveError:   'The default filters could not be saved',
      },
    },
    whatsapp: {
      close:    'Close',
      cancel:   'Cancel',
      optional: 'optional',
      required: 'Required',
      back:     'Back to chats',
      newConversation:     'New chat',
      businessNumber:      'Business number: {phone}',
      notConfigured:       'WhatsApp is not configured in the helpdesk: you can read the chats but not send messages.',
      emptyList:           'No chats match these filters',
      selectConversation:  'Select a chat',
      resolve:             'Resolve',
      resolveHint:         'Marks the chat as resolved. If the customer writes again, it reopens by itself.',
      conversationStarted: 'Chat started',
      filters: {
        all:        'All',
        everyone:   'All',
        mine:       'Mine',
        unassigned: 'Unassigned',
        search:     'Search by name, phone or message…',
      },
      status: {
        open:     'Open',
        pending:  'Pending',
        resolved: 'Resolved',
        closed:   'Closed',
      },
      messageStatus: {
        received:  'Received',
        queued:    'Sending',
        sent:      'Sent',
        delivered: 'Delivered',
        read:      'Read',
        failed:    'Not sent',
      },
      messageType: {
        text:        'Message',
        image:       'Photo',
        audio:       'Audio',
        video:       'Video',
        document:    'Document',
        sticker:     'Sticker',
        location:    'Location',
        contacts:    'Contact',
        template:    'Template',
        button:      'Button reply',
        interactive: 'Interactive reply',
        reaction:    'Reaction',
        unsupported: 'Unsupported message',
      },
      message: {
        template:    'Template: {name}',
        file:        'File',
        image:       'Image',
        audio:       'Audio',
        video:       'Video',
        document:    'Document',
        location:    'Location',
        download:    'Download',
        mediaError:  'The file could not be downloaded',
        mediaGone:   'File not available (WhatsApp no longer keeps it)',
        unsupported: 'Message type WhatsApp does not allow showing here',
        failed:      'Could not be sent',
      },
      thread: {
        loadOlder: 'Load earlier messages',
        empty:     'No messages yet',
        today:     'Today',
        yesterday: 'Yesterday',
      },
      composer: {
        placeholder:        'Type a message',
        captionPlaceholder: 'Add a comment (optional)',
        send:               'Send',
        attach:             'Attach file',
        removeFile:         'Remove file',
        sendTemplate:       'Send template',
        hint:               'Enter to send, Shift+Enter for a new line',
        windowUntil:        'you can write freely until {date}',
        windowClosed:       'More than 24 h since the customer\'s last message: WhatsApp only allows sending an approved template.',
        fileTooBig:         'The file is over the 16 MB WhatsApp allows',
        imageTooBig:        'Images cannot be over 5 MB on WhatsApp',
      },
      templates: {
        title:        'Send template',
        newTitle:     'New WhatsApp chat',
        phone:        'Phone (with country code)',
        name:         'Contact name',
        template:     'Approved template',
        none:         'There are no approved templates in Meta',
        variable:     'Variable {n}',
        preview:      'Preview',
        invalidPhone: 'Invalid phone: include the country code (e.g. +34)',
      },
      details: {
        title:        'Details',
        status:       'Status',
        assignee:     'Assignee',
        ticket:       'Ticket',
        openTicket:   'Open ticket #{id}',
        createTicket: 'Create ticket',
        unlinkTicket: 'Unlink ticket',
        contact:      'Contact',
        name:         'Name',
        phone:        'Phone',
        copyPhone:    'Copy phone',
        phoneCopied:  'Phone copied',
        window:       '24 h window',
        windowOpen:   'Open until {date}',
        windowClosed: 'Closed: templates only',
        windowHint:   'WhatsApp only allows writing freely for 24 h after the customer\'s last message.',
        created:      'Created on',
        lastMessage:  'Last message on',
      },
    },
  },
};

export default messages;
